{
	"404": {
		"title": "Cette page n'existe pas.",
		"back": "Revenir à l'accueil",
		"course": "Ce cours n'existe pas ou a été supprimé.",
		"organization": "Cette organisation n'existe pas ou a été supprimée.",
		"post": "Cette publication n'existe pas ou a été supprimée.",
		"user": "Cet utilisateur n'existe pas.",
		"quiz": "Ce quiz n'existe pas ou a été supprimé.",
		"shareroom": "Cette classroom n'existe pas ou a été supprimée.",
		"group": "Ce groupe n'existe pas ou a été supprimé.",
		"oops": "Ooops !",
		"article": "Cet insight n'existe pas ou a été supprimé.",
		"carousel": "Ce carrousel n'existe pas ou a été supprimé.",
		"white_page": {
			"message": "Une erreur s’est produite 😞",
			"button": {
				"title": "Veuillez réessayer svp"
			}
		}
	},
	"discussion": {
		"edit": {
			"title": "Éditer un groupe de discussion."
		},
		"new": {
			"title": "Créer un groupe de discussion."
		},
		"name": {
			"placeholder": "Nom du groupe..."
		},
		"description": {
			"placeholder": "Description succinte..."
		},
		"save": {
			"success": "Le groupe a bien été sauvegardé",
			"error": "Une erreur est survenue lors de la sauvegarde du groupe"
		},
		"list": {
			"title": "Mes groupes de discussion."
		}
	},
	"shareroom": {
		"edit": {
			"title": "Éditer une Classroom.",
			"message": "Posez la premiere brique !\nC’est simple, donnez une identité à votre classroom et rendez la unique.",
			"add_member": {
				"title": "Ajoutez un animateur et des co-animateurs"
			},
			"add_members": "Vous pouvez ajouter jusqu'à 3 membres dans votre équipe pédagogique ",
			"info": {
				"title": "Donnez une identité à votre classroom !"
			},
			"banner": {
				"sizing": "{{width}} * {{height}}"
			},
			"cancel_modal": {
				"title": "<< {{name}} >>",
				"big_title": "Êtes-vous sûr de bien vouloir abandonner le processus de création ?",
				"description": "Ne ratez pas cette chance inouie, revenez sur votre décision ! Créez votre sanctuaire de savoir et de partage."
			},
			"back": "Revenir à la création",
			"cancel": "Abandonner "
		},
		"new": {
			"title": "Créer une Classroom."
		},
		"name": {
			"placeholder": "Nom de la Classroom..."
		},
		"description": {
			"placeholder": "Description succinte..."
		},
		"save": {
			"success": "La Classroom a bien été sauvegardée",
			"error": "Une erreur est survenue lors de la sauvegarde de la Classroom"
		},
		"list": {
			"title": "Mes Classrooms."
		},
		"workspace": {
			"back": "Retourner sur votre classroom"
		},
		"workspaces": {
			"title": "Choisissez un espace :",
			"limit_reached_modal": {
				"title": "La version actuelle de Jaangal permet de créer 10 espaces maximum.",
				"report": "Prévenez-moi lorsque la version prochaine sera disponible."
			},
			"request": {
				"sent": "Votre demande a bien été envoyée",
				"error": "Votre demande n'a pas été envoyée correctement"
			}
		},
		"administrator": {
			"limit_reached_modal": {
				"title": "Vous ne pouvez pas ajouter un nouveau membre dans l'équipe pédadogique !",
				"description": "Votre équipe pédagogique a atteint la taille maximum autorisée. Enlevez des membres existants pour pouvoir en ajouter des nouveaux."
			}
		},
		"cancel_modal": {
			"title": "Vous ne pouvez pas supprimer cette classroom !"
		},
		"editor": {
			"presentation": {
				"video": {
					"new": "Ajouter une vidéo de présentation"
				},
				"text": {
					"placeholder": "Ajouter une description"
				}
			}
		},
		"about": {
			"presentation": {
				"title": "Présentation",
				"owner": {
					"description": "Rendez votre classroom plus accueillante !\nC’est simple. Faites-nous part de votre vocation, de vos motivations, de votre vision et des avantages pour vos apprenants."
				},
				"member": {
					"description": "Le formateur n'a pas encore publié la présentation de sa classroom. Revenez plus tard pour voir la mise à jour."
				}
			},
			"objective": {
				"title": "Objectifs du cours",
				"owner": {
					"description": "Faites de cet espace un sanctuaire de connaissances !\nParlez-nous de vos objectifs et ce que peuvent gagner les apprenants en s'abonnant."
				},
				"member": {
					"description": "Le formateur n'a pas encore publié les objectifs de sa classroom. Revenez plus tard pour voir la mise à jour."
				}
			},
			"formatCourse": {
				"title": "Format de cours",
				"owner": {
					"description": "Dispensez vos cours à votre guise !\nDéfinissez le format et profitez de nos fonctionnalités multiples pour plus de pédagogie."
				},
				"member": {
					"description": "Le formateur n'a pas encore publié le formats des cours de sa classroom. Revenez plus tard pour voir la mise à jour."
				}
			},
			"schedule": {
				"title": "Horaires de cours",
				"owner": {
					"description": "Planifiez ! C'est la clé de la réussite.\nNotifiez en avance à vos apprenants les horaires de vos cours."
				},
				"member": {
					"description": "Le formateur n'a pas encore publié les horaires de cours de sa classroom. Revenez plus tard pour voir la mise à jour."
				}
			},
			"targetAudience": {
				"title": "Public ciblé",
				"owner": {
					"description": "Donnez une dimension à votre classroom !\nDites-nous à qui cette classroom est destinée et les prérequis nécessaires pour s'y abonner."
				},
				"member": {
					"description": "Le formateur n'a pas encore indiqué le public ciblé de sa classroom. Renevez plus tard pour voir la mise à jour."
				}
			},
			"teachers": {
				"title": "Equipe pédagogique"
			}
		},
		"dashboard": {
			"menu": {
				"title": {
					"GENERAL": "Général",
					"DEALING": "Transactions",
					"SETTING": "Paramètres"
				}
			},
			"check": {
				"title": "Vérification",
				"description": "Pour susciter l'intérêt de vos potentiels apprenants, remplissez la page de présentation de votre classroom en donnant plus d'informations sur les objectifs du cours, les horaires, le public ciblé ... ",
				"fill_about_page": "Remplir la page \"à propos\""
			},
			"pricing": {
				"title": "Tarification",
				"description": "Dans cette étape, nous vous laissons définir le mode d'abonnement de votre classroom ainsi que son tarif. ",
				"form": {
					"subscription_mode": {
						"label": "Mode d'abonnement",
						"MONTHLY": "Mensuel",
						"YEARLY": "Annuel ",
						"UNIQUE": "Unique"
					},
					"subscription_price": "Prix de l'abonnement",
					"currency": {
						"label": "Devise",
						"XOF": "FCFA",
						"EUR": "Euro",
						"USD": "Dollar américain ",
						"CHF": "Franc Suisse"
					}
				},
				"update": {
					"forbidden": {
						"message": "Vous ne pouvez pas modifier le prix de votre classroom lorsqu'au moins un apprenant a un abonnement actif.",
						"title": "Modification échouée "
					}
				}
			},
			"settings": {
				"success": {
					"title": "Monétisation activée !",
					"description": "Votre public ciblé peut retrouver votre classroom et s'y abonner en payant le tarif indiqué. Partagez l'information afin d'avoir beaucoup d'apprenants."
				},
				"sucess": {
					"button": {
						"label": "Retourner sur le dashboard"
					}
				}
			},
			"general": {
				"monetize": {
					"button": {
						"label": "Monétiser ma classroom "
					},
					"description": "Votre savoir peut être monnayé ! Faites de votre classroom une source de gains. D’inombrables fonctionnalités vous attendent comme ce Dashboard qui est votre tableau de bord pour visualiser les rapports d’évolution de vos actions durant le temps. Il vous reste qu’une chose, activer la monétisation de votre classroom en cliquant sur le bouton ci-dessous .\n"
				},
				"income": {
					"title": "Mes revenus "
				},
				"reviews": {
					"title": "Mes avis"
				},
				"learners": {
					"title": "Mes apprenants"
				},
				"info": {
					"income": {
						"title": "Vos revenus reprèsentent la somme totale de ...."
					},
					"learners": {
						"title": "Vos apprenants représentent ..."
					}
				},
				"all_learners": {
					"title": "Total des apprenants "
				},
				"audience": {
					"description": "Evolution de votre audience en fontion du temps "
				},
				"recent_learners": {
					"description": "Les apprenants les plus récents "
				},
				"last_learners": {
					"descrption": "Les derniers apprenants qui ont rejoint votre classroom "
				}
			},
			"transactions": {
				"info": {
					"reviews": {
						"title": "Les avis de vos apprenants"
					},
					"revenue": {
						"title": "Vos revenus reprèsentent la somme totale de ...."
					},
					"balance": {
						"title": "Votre réel décaissable est le montant que vous pouvez recevoir sur votre mobile money."
					}
				},
				"revenue": {
					"title": "Mes revenus "
				},
				"balance": {
					"title": "Mon solde"
				},
				"other": {
					"title": "Autre"
				},
				"cashout": {
					"title": "Décaissements ",
					"null": "Vous n'avez aucun abonnement pour le moment !",
					"description": "Vous pouvez retirer votre solde toutes les fins du mois."
				},
				"table": {
					"price": {
						"title": "Prix classroom"
					},
					"periodicity": {
						"title": "Périodicité",
						"description": "au "
					},
					"balance": {
						"title": "Solde"
					},
					"action": {
						"title": "Action"
					},
					"withdraw_button": {
						"label": "Retirer"
					},
					"withdrawn_button": {
						"label": "Solde retiré "
					},
					"null": "Vous n'avez aucune transaction effectuée durant cette période.",
					"object": {
						"title": "Objet"
					},
					"date": {
						"title": "Date & Heure "
					},
					"mode": {
						"title": "Mode de paiement"
					},
					"amount": {
						"title": "Montant"
					},
					"subscription_mode": {
						"UNIQUE ": "Abonnement unique ",
						"YEARLY": "Abonnement annuel",
						"MONTHLY": "Abonnement mensuel "
					},
					"cashout": {
						"title": "Décaissement"
					}
				},
				"history": {
					"title": "Historique de vos transactions",
					"description": "Les dernières transactions que vous avez effectuées "
				}
			}
		},
		"subscription": {
			"summary": {
				"title": "Récapitulatif",
				"description": "Vous souhaitez rejoindre la classroom. Nous vous en remercions. Vous y êtes presque !\n\nAfin de confirmer votre inscription, nous vous invitons à lire les détails de votre abonnement puis à cliquer sur le bouton “Valider”.\n"
			},
			"detail": {
				"title": "Détails de l’abonnement"
			},
			"classroom": {
				"title": "Classroom :"
			},
			"mode": {
				"title": "Mode d’abonnement :",
				"WEEKLY": "Semaine",
				"MONTHLY": "Mois",
				"YEARLY": "An",
				"UNIQUE": "Unique"
			},
			"startdate": {
				"title": "Date de début :"
			},
			"enddate": {
				"title": "Date de fin :"
			},
			"price": {
				"title": "Prix de l'abonnement :"
			},
			"title": "Choississez le mobile money avec lequel vous voulez payer votre abonnement puis renseignez votre numéro de téléphone. Des frais de paiement s'appliqueront selon l'opérateur choisi.",
			"mobile_money": {
				"title": "Mobile money"
			},
			"phone": {
				"title": "Numéro de téléphone"
			},
			"progress": {
				"title": "Traitement en cours",
				"description": "Veillez patienter et suivre les instructions que vous recevrez."
			},
			"success": {
				"title": "Abonnement réussi ",
				"description": "Votre demande d'inscription a été acceptée."
			},
			"failed": {
				"title": "Abonnement échoué",
				"description": "Votre inscription a échoué."
			},
			"renew": {
				"description": "En un clic, renouvelez votre abonnement pour rejoindre votre classroom et reprendre vos cours !",
				"title": "Renouveler mon abonnement"
			},
			"discover": {
				"title": "Découvrir"
			}
		},
		"operation": {
			"cashout": {
				"description_1": "Voulez-vous recevoir le solde de ",
				"description_2": "via votre mobile money ?",
				"mode": {
					"WV_CH": "Wave",
					"em_CH": "E-Money",
					"OM_CH": "Orange Money",
					"FM_CH": "Free Money",
					"WIZALL": "Wizall"
				},
				"phone": {
					"title": "Numéro de téléphone"
				}
			},
			"progress": {
				"title": "Traitement en cours",
				"description ": "Veillez patienter, vous recevrez votre argent sous peu."
			}
		},
		"delete": {
			"title": "Vous ne pouvez pas supprimer cette classroom !",
			"description": "Lorsqu’une classroom est monétisée et qu’il y a au moins un membre de la classroom qui dispose d’un abonnement actif, vous devez obligatoirement respecter vos engagements et poursuivre la formation.\nNous vous prions de relire  les conditions de monétisation de la classroom."
		},
		"guide": {
			"title": "Un tour dans votre classroom",
			"description": "Soyez le maître de votre espace de contenu.\nSur Jaangal, vous avez la possibilité de monétiser vos connaissances avec une communauté de passionnés. \nPour créer votre classroom payante, il vous suffit de cliquer sur le bouton ci-après.",
			"dashboard": {
				"message": "Visualisez vos données",
				"description": "C’est votre espace de gestion. Vous pouvez configurer vos classroom, retrouver la liste de vos apprenants, suivre l’historique de vos paiements et bien plus encore !"
			},
			"calendar": {
				"message": "Planifiez vos activités",
				"description": "Vous êtes le maître de votre temps. \nIndiquez vos heures de cours en fonction de vos disponibilités pour permettre à nos utilisateurs de rejoindre votre classroom.\n"
			},
			"live": {
				"message": "Organisez des sessions en visioconférence",
				"description": "Des cours en live comme si vous étiez en classe !\n\nAvec la future fonctionnalité LIVE, vous pourrez partager vos connaissances avec vos apprenants dans une salle de classe virtuelle. \nVous pourrez organiser des sessions instantanées ou planifiées pour vos classrooms pour 50 apprenants au maximum par session !"
			},
			"workspaces": {
				"message": "Subdivisez votre classroom",
				"description": "Créez des espaces pour organiser vos activités par petits groupes. Vous gagnerez en efficacité !"
			},
			"activity": {
				"message": "Discuter, partager avec vos apprenants à travers  le fil d’actualité ",
				"description": "Supports de cours partagés ? Live programmé ? Nouvel apprenant ? Gardez un oeil sur les activités de votre classroom."
			}
		},
		"terms": {
			"title": "Conditions de la monétisation",
			"intro": "Pour gagner de l’argent sur notre plateforme Jaangal, vous devez :",
			"rule_1": "Être majeur (avoir 18 ans révolus) au moment de créer votre classroom,",
			"rule_2": "Publier du contenu authentique, qui vous appartient et qui ne fait pas l’objet de plagiat ni de poursuite et de litige,",
			"rule_3": "Respecter vos engagements en termes de quantum horaire, ",
			"rule_4": "Accepter le versement d’une commission de 25 % à Jaangal pour chaque abonnement mensuel et/ou unique,",
			"rule_5": "Avoir un compte mobile money pour le versement à J+30 de vos paiements.",
			"notice": "Jaangal se réserve le droit de suspendre ou résilier tout compte utilisateur qui aura enfreint les règles de respect et de propriété intellectuelle.",
			"accept": "J’accepte de recevoir des informations à propos des offres concernant la monétisation. "
		},
		"dashbaord": {
			"general": {
				"chart": {
					"description": "Cette fonctionnalité n'est pas encore disponible."
				}
			},
			"learners": {
				"information_bubble": "Nombre d'apprenants qui possèdent un abonnement actif"
			},
			"incomes": {
				"information_bubble": "C'est le montant global que vous avez eu à collecter depuis la monétisation de votre classroom."
			},
			"balance": {
				"information_bubble": "C'est le montant que vous pouvez retirer."
			}
		},
		"premium": {
			"unsubscribtion": "vient de se désabonner votre classroom "
		},
		"free": {
			"unsubscribtion": "vient de quitter votre classroom "
		},
		"notification": {
			"post": "vient de publier un post dans la classroom ",
			"instant_live ": "vient de démarrer un live dans la classroom ",
			"programmed_live ": "vient de programmer un live dans la classroom ",
			"quiz": "vient de publier un quiz dans la classroom ",
			"course": "vient de publier un cours dans la classroom ",
			"insight": "vient de publier un insight dans la classroom ",
			"review": "a laissé un avis sur votre classroom"
		},
		"review": {
			"infos": "Donner votre avis sur la classroom",
			"stars": {
				"1": "Décevant",
				"2": "Moyen",
				"3": "Bien",
				"4": "Super",
				"5": "Parfait !"
			},
			"empty": "Il n'y a pas encore d'avis sur cette classroom.",
			"placeholder": "Votre commentaire (optionnel)",
			"title": "{{count}} Avis",
			"date": "Posté le {{date}}"
		},
		"add_review": {
			"button": "Ajouter un avis "
		},
		"status_change": "a rendu payante la classroom",
		"delete_feedback": {
			"title": "Voulez-vous vraiment supprimer cet avis ?",
			"description": "Ceci est action irréversible, cliquer sur annuler pour revenir sur votre décision."
		},
		"role": {
			"ADMINISTRATOR": "Formateur",
			"MEMBER": "Apprenant",
			"ALL": "Tout"
		},
		"pdf": {
			"title": "Liste PDF",
			"empty": "Aucun pdf disponible"
		}
	},
	"group": {
		"SHAREROOM": {
			"edit": {
				"public": {
					"label": "Classroom publique"
				},
				"title": "Éditer votre Classroom.",
				"message": "Donner une identité à votre classroom !",
				"privacy": {
					"label": "Classroom privée",
					"infos": "Une Classroom privée n'apparaît pas dans les résultats de recherche."
				},
				"access": {
					"label": "Classroom ouverte",
					"infos": "Une Classroom ouverte est accessible pour tous les utilisateurs de Jaangal sans demande d'adhésion."
				},
				"associate_to_organization": "Rattacher votre Classroom à une page établissement"
			},
			"save": {
				"success": "La Classroom a bien été sauvegardée",
				"error": "Une erreur est survenue lors de la sauvegarde de la Classroom"
			},
			"new": {
				"title": "Créer votre Classroom en 2 étapes !"
			},
			"name": {
				"placeholder": "Nom de la Classroom..."
			},
			"description": {
				"placeholder": "Description succincte..."
			},
			"owner": {
				"title": "Classroom créée par "
			},
			"associate_org": {
				"title": "Classroom rattachée à "
			},
			"toast": {
				"leave": {
					"success": "Vous avez bien quitté la Classroom"
				},
				"delete": {
					"success": "La Classroom a bien été supprimée",
					"error": "Une erreur est survenue lors de la suppression"
				}
			},
			"categories": {
				"title": "Thématiques de la classroom"
			},
			"members": {
				"list": {
					"empty": "Cette Classroom n'a pas encore de membres"
				}
			},
			"join": {
				"success": "Vous êtes maintenant membre de la Classroom {{name}}"
			},
			"invited": {
				"title": "Vous avez reçu une invitation pour rejoindre la Classroom {{name}}"
			},
			"pending": "Votre demande est en attente de validation par un animateur.",
			"unauthorized": "Cette Classroom est privée. Pour la rejoindre, vous pouvez effectuer une demande.",
			"welcome": "Cette classroom est ouverte. Rejoignez-la en cliquant sur le bouton ci-dessous !",
			"delete": {
				"title": "Voulez-vous vraiment supprimer cette Classroom ?"
			},
			"grant": {
				"success": "L'utilisateur a bien été ajouté à la Classroom {{name}}",
				"info": "a demandé à rejoindre la classroom."
			},
			"leave": {
				"title": "Voulez-vous vraiment quitter cette Classroom ?",
				"message": "Vous devrez effectuer une nouvelle demande pour accéder à son contenu."
			},
			"cancel_request": {
				"title": "Voulez-vous vraiment retirer votre demande pour rejoindre cette Classroom ?"
			},
			"role": {
				"ADMINISTRATOR": "Formateur",
				"MEMBER": "Apprenant"
			},
			"indicative_role": {
				"ADMINISTRATOR": "Vous êtes formateur",
				"MEMBER": "Vous êtes apprenant"
			},
			"thumbnail": {
				"members_count": {
					"other": "{{count}} apprenants",
					"one": "{{count}} apprenant",
					"zero": "{{count}} apprenant"
				},
				"admins_count": "{{count}} animateurs",
				"animated_by": "Classroom animée par :"
			},
			"menu": {
				"leave": "Quitter cette Classroom"
			},
			"auth": {
				"incentive": "Rejoignez la Classroom {{name}} en vous connectant à Jaangal"
			},
			"rules": {
				"placeholder": "Vous pouvez ajouter des règles pour votre Classroom..."
			},
			"thumbnail_badge": "Classroom"
		},
		"banner": {
			"add": "Bannière"
		},
		"tab": {
			"activity": "Activité",
			"community": "Membres",
			"workspaces": "Espaces",
			"about": "A propos",
			"live": "Live",
			"calendar": "Calendrier",
			"dashboard": "Tableau de bord",
			"feedback": "Avis",
			"pdf": "PDF"
		},
		"edit": {
			"quit": "Abandonner l'édition",
			"add_members": "Ajouter vos élèves et/ou membres"
		},
		"creation": {
			"quit": "Abandonner la création"
		},
		"DISCUSSION_GROUP": {
			"save": {
				"success": "Le groupe a bien été sauvegardé",
				"error": "Une erreur est survenue lors de la sauvegarde du groupe"
			},
			"edit": {
				"title": "Éditer votre groupe de discussion.",
				"message": "Créer votre Groupe de discussion en 2 étapes !",
				"privacy": {
					"label": "Groupe privé",
					"infos": "Un groupe privé n'apparaît pas dans les résultats de recherche."
				},
				"access": {
					"label": "Groupe ouvert",
					"infos": "Un groupe ouvert est accessible à tous les utilisateurs de Jaangal sans demande d'adhésion."
				},
				"associate_to_organization": "Rattacher votre groupe de discussion à un établissement"
			},
			"new": {
				"title": "Créer votre groupe de discussion en 2 étapes !"
			},
			"name": {
				"placeholder": "Nom du groupe..."
			},
			"description": {
				"placeholder": "Description succincte..."
			},
			"owner": {
				"title": "Groupe créé par "
			},
			"associate_org": {
				"title": "Groupe rattaché à "
			},
			"toast": {
				"delete": {
					"success": "Le groupe a bien été supprimé",
					"error": "Une erreur est survenue lors de la suppression"
				},
				"leave": {
					"success": "Vous avez bien quitté le groupe"
				},
				"copied_link": "Lien d'invitation copié dans le presse-papiers"
			},
			"categories": {
				"title": "Thématiques du groupe"
			},
			"members": {
				"list": {
					"empty": "Ce groupe n'a pas encore de membres."
				}
			},
			"join": {
				"success": "Vous êtes maintenant membre du groupe {{name}}"
			},
			"invited": {
				"title": "Vous avez reçu une invitation pour rejoindre le groupe {{name}}"
			},
			"pending": "Votre demande est en attente de validation par le groupe.",
			"unauthorized": "Ce groupe est privé. Pour le rejoindre, vous pouvez effectuer une demande.",
			"welcome": "Ce groupe est ouvert. Rejoignez-le en cliquant sur le bouton ci-dessous !",
			"delete": {
				"title": "Voulez-vous vraiment supprimer ce groupe ?"
			},
			"grant": {
				"success": "L'utilisateur a bien été ajouté au groupe {{name}}",
				"info": "a demandé à rejoindre le groupe."
			},
			"leave": {
				"title": "Voulez-vous vraiment quitter ce groupe ?",
				"message": "Vous devrez effectuer une nouvelle demande pour accéder à son contenu."
			},
			"cancel_request": {
				"title": "Voulez-vous vraiment retirer votre demande pour rejoindre ce groupe ?"
			},
			"role": {
				"ADMINISTRATOR": "Administrateur",
				"MEMBER": "Membre"
			},
			"indicative_role": {
				"ADMINISTRATOR": "Vous êtes administrateur",
				"MEMBER": "Vous êtes membre"
			},
			"thumbnail": {
				"members_count": {
					"other": "{{count}} membres",
					"one": "{{count}} membre",
					"zero": "{{count}} membre"
				},
				"admins_count": "{{count}} administrateurs",
				"animated_by": "Animé par :"
			},
			"menu": {
				"leave": "Quitter ce groupe"
			},
			"auth": {
				"incentive": "Rejoignez le groupe {{name}} en vous connectant à Jaangal"
			},
			"rules": {
				"placeholder": "Vous pouvez ajouter des règles pour votre groupe..."
			},
			"public": {
				"invitation_button": "Inviter",
				"copy_link": "Copier lien d'invitation"
			}
		},
		"members": {
			"list": {
				"title": "Membres ({{count}})"
			}
		},
		"join": {
			"button": "Rejoindre",
			"request": "Demander à rejoindre",
			"request_send": "En attente",
			"accept_invitation": "Accepter l'invitation"
		},
		"request": {
			"success": "Votre demande a bien été envoyée",
			"error": "Une erreur est survenue lors de l'envoi de votre demande"
		},
		"grant": {
			"error": "Une erreur est survenue lors de l'ajout de l'utilisateur",
			"button": "Accepter",
			"modal": {
				"title": "Ajouter un membre."
			},
			"accept": "Accepter {{name}} en tant que : ",
			"temporary": "Accepter {{name}} en tant que membre ?"
		},
		"menu": {
			"cancel_request": "Annuler ma demande"
		},
		"rules": {
			"button": "Consulter les règles du groupe",
			"title": "Règles du groupe."
		},
		"edition": {
			"name": "Nom",
			"description": "Description",
			"category": "Catégorie",
			"rules": "Règles du groupe"
		},
		"DISCUSSION": {
			"thumbnail_badge": "Groupe de discussion"
		},
		"goback": {
			"organisation": "Aller vers la page établissement"
		}
	},
	"social_sharing": {
		"message": "Hello Guys, j'ai trouvé ceci intéressant sur Jaangal."
	},
	"app_name": "Jaangal",
	"og_title": "Jaangal - Premier réseau social éducatif africain",
	"logout": "Se déconnecter",
	"reset": "Réinitialiser",
	"back": "Retour",
	"rename": "Renommer",
	"add": "Ajouter",
	"edit": "Éditer",
	"create": "Créer",
	"validate": "Valider",
	"delete": "Supprimer",
	"cancel": "Annuler",
	"publish": "Publier",
	"confirm": "Confirmer",
	"withdraw": "Retirer",
	"finish": "Terminer",
	"remove": "Retirer",
	"save": "Enregistrer",
	"quit": "Quitter",
	"explore": "Explorer",
	"feed-link": "Feed",
	"planete": "Planete",
	"share": "Partager",
	"close": "Fermer",
	"try_again": "Réessayer ",
	"download": "Télécharger",
	"ignore": "Ignorer ",
	"subscribe": "S'abonner",
	"discover": "Découvrir",
	"resubscribe": "Se réabonner",
	"start": "Commencer",
	"accept": "Accepter",
	"noted": "Compris ",
	"donate": "Faire un don",
	"error_default": "Une erreur est survenue...",
	"error": "Erreur",
	"success": "Succès",
	"add_tags": "Tags séparés par une virgule (Entrée pour valider)",
	"info": "Information",
	"views": "vues",
	"in": "dans",
	"coming_soon": "Bientôt disponible",
	"open": "Ouvert",
	"seeAlso": "Contenus similaires : ",
	"see_more": "Afficher tout",
	"next": "Suivant",
	"previous": "Précédent",
	"see_less": "Afficher moins",
	"more_button": "Plus",
	"filter_button": "Filtrer",
	"see_all": "Tout voir",
	"favorite": "Favoris",
	"day": "Jour",
	"month": "Mois",
	"year": "Année",
	"today": "Aujourd'hui",
	"filter": {
		"SEVENDAYS": "7 derniers jours ",
		"THREEMONTHS": "3 derniers mois ",
		"SIXMONTHS": "6 derniers mois ",
		"TWELVEMONTHS": "12 derniers mois "
	},
	"date_month_0": "Janvier",
	"date_month_1": "Février",
	"date_month_2": "Mars",
	"date_month_3": "Avril",
	"date_month_4": "Mai",
	"date_month_5": "Juin",
	"date_month_6": "Juillet",
	"date_month_7": "Août",
	"date_month_8": "Septembre",
	"date_month_9": "Octobre",
	"date_month_10": "Novembre",
	"date_month_11": "Décembre",
	"short_date_month_0": "Jan",
	"short_date_month_1": "Fév",
	"short_date_month_2": "Mar",
	"short_date_month_3": "Avr",
	"short_date_month_4": "Mai",
	"short_date_month_5": "Juin",
	"short_date_month_6": "Juillet",
	"short_date_month_7": "Août",
	"short_date_month_8": "Sept",
	"short_date_month_9": "Oct",
	"short_date_month_10": "Nov",
	"short_date_month_11": "Déc",
	"short_date_1": "Lun",
	"short_date_2": "Mar",
	"short_date_3": "Mer",
	"short_date_4": "Jeu",
	"short_date_5": "Ven",
	"short_date_6": "Sam",
	"short_date_7": "Dim",
	"check": "Vérifier",
	"checked": "Vérifié",
	"empty_data": "Vous n'avez aucun apprenant pour le moment. ",
	"ok": "Ok",
	"feedback": {
		"date": "Posté le {{date}}",
		"stars": {
			"1": "Décevant",
			"2": "Moyen",
			"3": "Bien",
			"4": "Super",
			"5": "Parfait !"
		},
		"placeholder": "Votre commentaire (optionnel)",
		"title": "Avis"
	},
	"code": {
		"message": "Vous n’avez pas reçu le code ?",
		"resend": "Renvoyer le code "
	},
	"post": {
		"title": "Post",
		"input": {
			"placeholder": "Partager avec la communauté...",
			"submit": "Publier",
			"image": "Image"
		},
		"image": {
			"add": "Images",
			"edit": "Modifier l'image"
		},
		"pdf": {
			"add": "PDF",
			"open": "Ouvrir le pdf"
		},
		"video": {
			"add": "Vidéo"
		},
		"shared": "a partagé ceci 👇🏾",
		"shareroom": {
			"infos": "dans {{shareroom}}"
		},
		"application": {
			"published": "vous invite à soutenir sa candidature",
			"deleted": "Cette candidature est annulée ou a été supprimée"
		},
		"group": {
			"infos": "dans {{group}}",
			"published": "a publié dans",
			"deleted": "Ce groupe est privé ou a été supprimé."
		},
		"quiz_published": "a publié un quiz",
		"published": "a publié ceci",
		"shared_self": "Vous avez partagé",
		"action": {
			"delete": "Supprimer",
			"like": "J'aime",
			"comment": "Commenter",
			"reply": "Répondre",
			"share": "Republier",
			"share_outside": "Partager",
			"share_detail": "Partager sur mon profil"
		},
		"comment": {
			"show": "Afficher les {{count}} commentaires",
			"more": "Voir plus de commentaires",
			"more_replies": "Voir plus de réponses",
			"input": {
				"placeholder": "Votre commentaire..."
			},
			"reply": {
				"placeholder": "Votre réponse...",
				"show": "Afficher les {{count}} réponses",
				"show_one": "Afficher la réponse"
			}
		},
		"share": {
			"modal": {
				"title": "Partager."
			},
			"title": "Partagé par :",
			"empty": "Cette publication n'a pas encore été partagée."
		},
		"delete": {
			"title": "Voulez-vous vraiment supprimer cette publication ?"
		},
		"create": {
			"title": "Créer une publication"
		},
		"edit": {
			"title": "Éditer une publication",
			"medias": "Ajouter un fichier :"
		},
		"course": {
			"deleted": "Ce cours est privé ou a été supprimé par son auteur."
		},
		"quiz": {
			"deleted": "Ce quiz est privé ou a été supprimé par son auteur."
		},
		"post": {
			"deleted": "Cette publication a été supprimée par son auteur."
		},
		"organization": {
			"deleted": "Cette organisation a été supprimée."
		},
		"live": {
			"deleted": "Ce live est annulé ou a été supprimé"
		},
		"delete_comment": {
			"title": "Voulez-vous vraiment supprimer ce commentaire ?"
		},
		"likes": {
			"title": "Aimé par :",
			"empty": "Cette publication n'a pas encore reçu de like."
		},
		"comments": {
			"title": "Commenté par : ",
			"empty": "Cette publication n'a pas encore reçu de commentaire."
		},
		"target": {
			"default": "Sur mon feed",
			"shareroom": "Partager dans une Classroom",
			"discussion": "Partager dans un groupe"
		},
		"article_published": "a publié un insight",
		"article": {
			"deleted": "Cet insight a été supprimé par son auteur"
		},
		"carousel": {
			"deleted": "Ce carrousel a été supprimé par son auteur"
		},
		"carousel_shared": "a partagé un carrousel en ",
		"carousel_published": "a publié un carrousel en ",
		"article_shared": "a partagé un insight",
		"course_published": "a publié un cours",
		"course_shared": "a partagé un cours",
		"quiz_shared": "a partagé un quiz",
		"livecourse_published": "a publié un cours live",
		"livecourse_shared": "a partagé un cours live"
	},
	"sort": "triez",
	"uninterest": "inintérêt",
	"welcome": "Bienvenue sur Jaangal",
	"expertise": {
		"english": "Anglais",
		"accounting ": "Comptabilité",
		"communication": "Communication",
		"community_manager": "Community manager",
		"data_science": "Data science",
		"justice_law": "Droit et justice",
		"entrepreneurship": "Entreprenariat & leadership ",
		"economy": "Economie",
		"finance": "Finance",
		"french": "Français",
		"gastronomy": "Gastronomie",
		"project_management": "Gestion de projet",
		"graphic_design": "Graphisme",
		"hospitality ": "Hôtellerie",
		"real_estate": "Immobilier",
		"computer_science": "Informatique",
		"journalism": "Journalisme",
		"literature": "Littérature ",
		"management": "Management",
		"mathematics": "Mathématiques",
		"marketing ": "Marketing",
		"media": "Media",
		"physic_chemistry": "Physique - Chimie",
		"philosophy": "Philosophie",
		"copywriter ": "Rédacteur",
		"human_and_social_sciences": "Sciences humaines et sociales",
		"UX_UI_design": "UI/UX design",
		"video_maker": "Videaste - Monteur",
		"other": "Autre"
	},
	"category": {
		"placeholder": {
			"course": "Catégorie de votre cours",
			"quiz": "Catégorie de votre quiz",
			"article": "Catégorie de votre insight",
			"DISCUSSION_GROUP": "Thématique principale du groupe",
			"SHAREROOM": "Thématique principale de la Classroom"
		},
		"ARTS_AND_CULTURE": "Arts et Culture",
		"BUSINESS_AND_MANAGEMENT": "Business et Management",
		"DESIGN": "Design",
		"ENGINEERING": "Ingénieries",
		"FINANCE_AND_ACCOUNTING": "Finance et Comptabilité",
		"HEALTH_AND_WELL_BEING": "Santé et Bien-être",
		"INDUSTRY": "Industrie",
		"INFORMATION_TECHNOLOGY": "Technologies de l'information",
		"LANGUAGES": "Apprentissage des langues",
		"MARKETING": "Marketing et communication",
		"MATHEMATICS": "Mathématiques",
		"SCIENCES": "Sciences",
		"SOCIAL_SCIENCES": "Sciences sociales",
		"OTHERS": "Autres",
		"ART": "Art",
		"CRAFT": "Artisanat",
		"CULTURE": "Culture",
		"MUSIC": "Musique",
		"FITNESS": "Fitness",
		"GLOBAL_HEALTH": "Santé générale",
		"NUTRITION": "Nutrition",
		"SPORT": "Sport",
		"WELL_BEING": "Bien-être",
		"BIG_DATA": "Big data et Business intelligence",
		"DATA_SCIENCE": "Science des données",
		"DATABASES": "Conception et développement de bases de données",
		"DATABASES_ORACLE": "Conception et développement de bases de données - Oracle",
		"DEVOPS": "DevOps",
		"PROGRAMMING_LANGUAGES": "Langages de programmation",
		"MOBILE_DEVELOPMENT": "Développement Mobile",
		"PRODUCTIVITY": "Productivité",
		"NETWORK_AND_SECURITY": "Réseaux et sécurité",
		"SYSTEM_ADMINISTRATION": "Administration système",
		"SOFTWARE_TESTING": "Tests logiciels",
		"WEB_DEVELOPMENT": "Développement Web",
		"BRAND_MARKETING": "Brand marketing",
		"COMMUNICATION": "Communication",
		"CONTENT_MARKETING": "Content Marketing",
		"DIGITAL_MARKETING": "Digital Marketing",
		"OPERATIONAL_MARKETING": "Marketing Opérationnel",
		"PRODUCT_MARKETING": "Product Marketing",
		"SEO": "SEO",
		"SOCIAL_MEDIA_MARKETING": "Social Media Marketing",
		"ACCOUNTING": "Comptabilité",
		"CRYPTOCURRENCY_AND_BLOCKCHAIN": "Cryptomonnaies et blockchain",
		"ECONOMY": "Économie",
		"FINANCE": "Finance",
		"FINANCIAL_ANALYSIS": "Analyse financière",
		"TRADING_AND_INVESTMENTS": "Trading et investissements",
		"DESIGN_THINKING": "Design Thinking",
		"GRAPHIC_MODELING": "Conception graphique et illustration",
		"MODELING_3D": "Conception 3D",
		"UX_DESIGN": "UX Design",
		"BUSINESS_STRATEGY": "Stratégie des Affaires",
		"LEADERSHIP": "Entrepreunariat et leadership",
		"PROJECT_MANAGEMENT": "Gestion de projets",
		"JUSTICE_AND_LAW": "Droit et justice",
		"ANIMAL_HEALTH": "Santé animale",
		"HEALTH_INFORMATICS": "Informatique de santé",
		"PSYCHOLOGY": "Psychologie",
		"GOVERNANCE_AND_SOCIETY": "Gouvernance et société",
		"ENGLISH": "Anglais",
		"ELECTRICAL_ENGINEERING": "Génie électrique",
		"MECHANICAL_ENGINEERING": "Génie mécanique",
		"EXPERIMENTAL_SCIENCE_AND_SUSTAINABILITY": "Développement durable",
		"PHYSICS_AND_ASTRONOMY": "Physique et astronomie",
		"CLOUD": "Cloud",
		"EDUCATION": "Education",
		"SANTE_MENTALE": "Santé Mentale",
		"MEDIAS": "Médias",
		"FRANCAIS": "Français",
		"MATHEMATIQUES": "Mathématiques",
		"HISTOIRE_GEOGRAPHIE": "Histoire-Géographie",
		"EDUCATION_MORALE_ET_CIVIQUE": "Éducation morale et civique",
		"SCIENCES_DE_LA_VIE_ET_DE_LA_TERRE": "Sciences de la vie et de la Terre",
		"PHYSIQUE_CHIMIE": "Physique-Chimie",
		"LANGUES": "Langues",
		"ARTS": "Arts",
		"EDUCATION_PHYSIQUE_ET_SPORTIVE": "Éducation Physique et Sportive",
		"TECHNOLOGIE_INFORMATIQUE": "Technologie-Informatique",
		"SCIENCES_ECONOMIQUES_ET_SOCIALES": "Sciences Économiques et sociales",
		"PHILOSOPHIE": "Philosophie",
		"BIOLOGIE_ECOLOGIE": "Biologie-Écologie",
		"COMPTABILITE": "Comptabilité"
	},
	"kyc": {
		"edit": {
			"modal": {
				"title": "Identification",
				"description": "Permettez nous de pouvoir vous contacter en cas de besoin.\nVeuillez renseigner votre numéro de téléphone.",
				"title ": "Renseigner votre numéro de téléphone"
			},
			"user_type": {
				"title": "Quel est votre profil ?"
			},
			"PROFESSIONAL": {
				"title": "Professionnel",
				"area": "Domaine de compétence"
			},
			"TEACHER": {
				"title": "Enseignant",
				"matricule": "Matricule"
			},
			"lastname": "Nom",
			"firstname": "Prénom",
			"email": "Adresse email ",
			"address": "Adresse ",
			"country": "Pays de résidence ",
			"identity": {
				"type": "Type de pièce d'identité ",
				"ID": {
					"label": "Carte d’identité nationale"
				},
				"PASSPORT": {
					"label": "Passeport"
				},
				"number": "Numéro de la piėce d’identité",
				"proof_of_identity": {
					"label": "Justificatif d'identité",
					"reminder": "Votre fichier ne doit pas dépasser {{fileSize}}Mb et doit être dans les formats suivants",
					"placeholder": "Téléverser votre justificatif d’identité"
				}
			},
			"phone_number": {
				"verify_link": "Vérifier",
				"label": "Numéro de téléphone"
			}
		},
		"verification": {
			"modal": {
				"title": "Vérification du numéro de téléphone saisi",
				"description": "Veuillez saisir le code reçu sur le numéro qui se termine par {{number}}. Vous n’avez pas reçu le code ?",
				"resend_link": "Renvoyer le code",
				"edit": {
					"otp_code": "Code de validation OTP"
				},
				"error": {
					"otp_code": "Le code OTP que vous avez saisi est incorrect. Veuillez le resaisir"
				}
			},
			"phone_number": {
				"toast": {
					"success": {
						"message": "La vérification de votre numéro a été un succès"
					},
					"error": {
						"message": "La vérification de votre numéro a été un échec"
					},
					"resend": {
						"success_title ": "Code OTP renvoyé ",
						"success_message ": "Veuillez vérifier si vous avez reçu le nouveau code OTP par message",
						"error_title": "Erreur survenue ",
						"error_message ": "Une erreur a été notée, nous vous renvoyons un nouveau code OTP"
					}
				}
			}
		}
	},
	"asset": {
		"image": "Photo",
		"video": "Vidéo",
		"pdf": "PDF",
		"audio": "Audio",
		"type": {
			"all": "Tous",
			"IMAGE": "Images",
			"VIDEO": "Vidéos",
			"AUDIO": "Audio",
			"DOCUMENT": "Documents"
		},
		"modal": {
			"asset_manager": "Ou depuis votre médiathèque"
		},
		"open": "Ouvrir"
	},
	"asset_manager": {
		"title": "Médiathèque",
		"mine": {
			"title": "Ma médiathèque"
		},
		"upload": {
			"title": "Déposez des fichiers.",
			"message": "Glissez-déposez ou cliquez ici",
			"message_mobile": "Ajouter des fichiers"
		},
		"files": {
			"count": "Vos fichiers ({{count}})."
		},
		"search": {
			"placeholder": "Rechercher un fichier...",
			"empty": "Aucun fichier ne correspond à votre recherche."
		},
		"empty": "Votre gestionnaire de fichier est vide. Téléchargez des fichiers sur Jaangal pour y accéder rapidement.",
		"asset": {
			"add": "Attacher à ma publication"
		},
		"gallery": {
			"error": "Ce fichier ne peut pas être prévisualisé"
		}
	},
	"video": {
		"quality": {
			"auto": "Auto"
		},
		"transcoding": {
			"error": "Une erreur est survenue lors du traitement de la vidéo.",
			"progress": "La vidéo est en cours de traitement, cette opération peut prendre plusieurs minutes. ({{progress}}%)"
		}
	},
	"live": {
		"xxx": "",
		"title": "Cours Live",
		"createdby": "Créé par",
		"participant": "Participants",
		"create": "Créer un live",
		"description": "Démarrer maintenant ou programmer un live et discuter avec d’autres personnes",
		"instant": "Lancer un live instantané",
		"scheduled": "Lancer un live programmé",
		"presentation": "Programmer votre Live en toute simplicité.",
		"titleplaceholder": "Donner un nom à votre live",
		"notificationwarning": "Tous les apprenants de la classroom seront notifiés au lancement",
		"autopublish": "Publier automatiquement un post sur la classroom",
		"delete": "Voulez-vous vraiment supprimer ce cours live ?",
		"deletefail": "Le cours live n'a pas été supprimé.",
		"deletesuccess": "Cours live supprimé avec succès !",
		"ongoing": "En cours",
		"upcoming": "À venir",
		"members": "Participants",
		"startedat": "Commence ",
		"from": "de",
		"to": "à",
		"createsuccess": "Cours live créé avec succès !",
		"createfail": "Impossible de créer un live",
		"threesold": "Vous avez atteint le nombre de cours lives autorisés dans une classroom",
		"allmembers": "Tous les membres de l’espace ",
		"deleteconfirm": "Voulez-vous vraiment supprimer ce cours live ?",
		"justlaunched": "vient de démarrer un cours live",
		"starting": "est en ligne sur",
		"inspace": "dans l'espace",
		"join": "Rejoindre",
		"copylink": "Copier le lien du live",
		"joininstantroom": "Participer",
		"start": "Démarrer le live",
		"copysuccess": "Lien copié dans le presse-papier !",
		"copyfailed": "Impossible de copier ce lien",
		"confirmed": "Participation confirmée",
		"declined": "Participation refusée ",
		"tobelaunched": "a programmé un cours live",
		"closed": "Ce cours live est terminé",
		"page": {
			"notificationwarning": "Tous les membres de l'espace seront notifiés au lancement",
			"autopublish": "Publier automatiquement un post sur la page"
		},
		"invite": "Inviter",
		"invitemembers": "Ajouter d'autres invités",
		"workspace": {
			"autopublish": "Publier automatiquement un post sur la classroom"
		},
		"joinascreator": "Accèder au live",
		"thumbnail": {
			"badge_label": "Cours Live"
		},
		"no_live": "Aucun live n'a été organisé pour le moment ici",
		"coming_soon": "Les lives seront biens disponibles sur la plateforme !"
	},
	"addDescription": "Ajouter une description",
	"launchLive": "Démarrer le live",
	"carousel": {
		"options": {
			"share": "Partager",
			"report": "Signaler",
			"setFav": "Ajouter à mes favoris",
			"title": "Options du Carrousel.",
			"setFullScreen": "Voir en plein écran"
		},
		"edit": {
			"title": "Editer le carrousel",
			"titleCarousel": "Titre",
			"category": "Catégorie",
			"language": "Langage"
		},
		"delete": {
			"title": "Voulez-vous vraiment supprimer ce carrousel ?",
			"message": ""
		},
		"post": {
			"checkbox": {
				"label_max_count": "Les carrousels ne peuvent pas dépasser {{max_count}} pages",
				"labelInfos": "En cochant cette case, votre carrousel sera accessible depuis la recherche",
				"label": "Ceci est un carrousel",
				"label_min_count": "Les carrousels doivent avoir minimum {{min_count}} pages"
			},
			"title": {
				"placeholder": "Ajouter un titre à votre carrousel"
			}
		},
		"info_warning": "Sur Jaangal, un carrousel doit contenir entre {{min_slide}} et {{max_slide}} slides.",
		"save": {
			"success": "Carrousel enregistré avec succés",
			"error": "Erreur de sauvegarde du carrousel"
		},
		"toast": {
			"delete": {
				"title": "",
				"message": ""
			}
		},
		"insightful": {
			"title": "Cliquez si vous trouvez ceci instructif",
			"tooltip": {
				"labelNotInsightful": "instructif ?",
				"label": {
					"IfInsightful": "instructif"
				}
			},
			"notification": {
				"label": "{{user}} a trouvé instructif votre carrousel {{carousel}}. Bravo !"
			}
		},
		"suggestions": "Carrousels du même auteur.",
		"detailedView": "Vue détaillée",
		"auth": {
			"incentive": "Découvrez d'autres carrousels en {{category}} en vous connectant à Jaangal"
		},
		"suggestions_same_category": "Carrousels de la même catégorie"
	},
	"seo": {
		"auth": {
			"title": "Jaangal"
		},
		"profile": {
			"title": "{{name}} | Jaangal",
			"picture": "Avatar de {{name}}",
			"banner": "Bannière de {{name}}"
		},
		"default": {
			"description": "Le réseau social éducatif africain dédié au partage de connaissances en ligne."
		},
		"organization": {
			"title": "{{name}} | Jaangal"
		},
		"group": {
			"DISCUSSION_GROUP": {
				"title": "Groupe {{name}} | Jaangal"
			},
			"SHAREROOM": {
				"title": "Classroom {{name}} | Jaangal"
			}
		},
		"course": {
			"title": "Cours {{name}} | Jaangal"
		},
		"search": {
			"title": "Découvrir | Jaangal"
		}
	},
	"report": {
		"action": "Signaler",
		"modal": {
			"title": "Signaler",
			"message": "Pour quelle raison souhaitez-vous signaler ce contenu ?"
		},
		"motive": {
			"FAKE_ACCOUNT": "Ce compte n'est pas une personne réelle",
			"IDENTITY_THEFT": "Usurpation d'identité",
			"HACKED": "Ce compte a été piraté",
			"SUICIDAL": "Personne à tendance suicidaire",
			"INAPPROPRIATE": "Ce contenu est inapproprié",
			"DECEASED": "Personne décédée",
			"CGU": "Violation des CGU de la plateforme",
			"HATE_SPEECH": "Discours de haine",
			"FORBIDDEN_SALES": "Ventes interdites",
			"DANGEROUS_ORGANIZATION": "Organisation dangereuse",
			"HARASSEMENT": "Harcèlement ou intimidation",
			"FAKE_NEWS": "Informations trompeuses",
			"OTHER": "Autre"
		},
		"mail": {
			"subject": "Signalement du contenu : {{url}}",
			"body": "{{url}}%0D%0A\nJe souhaite signaler le contenu ci-dessus aux administrateurs de Jaangal pour la raison suivante : %0D%0A\n{{motive}}"
		},
		"success": "Votre signalement a bien été envoyé aux administrateurs",
		"error": "Une erreur est survenue lors de l'envoi du signalement",
		"view": {
			"link": "Voir le contenu",
			"header": "{{contentType}} signalé(e) par :",
			"author": "Auteur du contenu :",
			"motive": "Motif : ",
			"moderate": "Supprimer le contenu",
			"moderated": "Contenu supprimé"
		},
		"moderate": {
			"title": "Êtes-vous sûr de vouloir supprimer ce contenu ?",
			"message": "Ce contenu ne sera plus disponible sur la plateforme Jaangal. Son auteur sera averti par notification.",
			"success": "Le contenu a bien été supprimé",
			"error": "Une erreur est survenue lors de la suppression du contenu"
		}
	},
	"workspace": {
		"new": {
			"title": "Créer un Espace."
		},
		"edit": {
			"title": "Éditer un Espace"
		},
		"name": {
			"placeholder": "Nom de l'Espace",
			"default": "Général"
		},
		"objective": {
			"placeholder": "Objectif de l'Espace"
		},
		"save": {
			"success": "L'Espace a bien été sauvegardé.",
			"error": "Une erreur est survenue lors de la sauvegarde de l'Espace."
		},
		"create": "Créer un Espace",
		"delete": {
			"title": "Voulez-vous vraiment supprimer cet Espace?",
			"message": "Certains contenus éducatifs pourraient ne plus être accessibles.",
			"success": "L'Espace a bien été supprimé.",
			"error": "Une erreur est survenue lors de la suppression"
		},
		"color": {
			"label": "Choisir une couleur"
		},
		"courses": {
			"title": "Cours ({{count}}).",
			"empty": "Cet Espace ne contient pas de cours.",
			"incentive": "Créer un cours pour cet Espace",
			"count": {
				"one": "{{count}} cours",
				"other": "{{count}} cours",
				"zero": "{{count}} cours"
			}
		},
		"quizzes": {
			"title": "Quiz ({{count}}).",
			"empty": "Cet Espace ne contient pas de quiz.",
			"incentive": "Créer un quiz pour cet Espace",
			"count": {
				"one": "{{count}} quiz",
				"other": "{{count}} quiz",
				"zero": "{{count}} quiz"
			}
		},
		"articles": {
			"title": "Insight ({{count}}).",
			"empty": "Cet Espace ne contient pas de insight.",
			"incentive": "Créer un insight pour cet Espace",
			"count": {
				"one": "{{count}} insight",
				"other": "{{count}} insight",
				"zero": "{{count}} insight"
			}
		},
		"assets": {
			"new": "Ajouter un document",
			"add": "Glisser un fichier ou cliquer ici pour ajouter un document.",
			"title": "Médiathèque ({{count}}).",
			"delete": {
				"success": "Le fichier a bien été supprimé.",
				"error": "Une erreur est survenue lors de la suppression.",
				"title": "Voulez-vous vraiment supprimer ce fichier ?"
			},
			"create": {
				"success": "Le fichier a bien été ajouté à l'Espace.",
				"error": "Le fichier n'a pas pu être ajouté.",
				"exists": "Le fichier est déjà disponible dans la Classroom"
			},
			"name": {
				"label": "Nom du fichier"
			},
			"limit": {
				"error": "Vous avez atteint le nombre maximum de fichiers dans cet espace"
			},
			"count": {
				"one": "{{count}} document",
				"other": "{{count}} documents",
				"zero": "{{count}} document"
			}
		},
		"filter": {
			"title": "Filtres.",
			"courses": "Cours",
			"quizzes": "Quiz",
			"articles": "Insight "
		},
		"size_limit_reached_modal": {
			"title": "Vous avez atteint la taille maximale de stockage sur cet Espace, essayez de supprimer des fichiers volumineux puis recommencez. Vous pouvez aussi cliquer sur le lien ci-dessous pour demander plus de stockage.",
			"report": "Je souhaite obtenir plus de stockage, tenez-moi au courant lorsque cela sera possible."
		},
		"request": {
			"sent": "Votre demande a bien été envoyée.",
			"error": "Votre demande n'a pas été correctement envoyée ."
		}
	},
	"content": {
		"COURSE": "Cours",
		"ARTICLE": "Insight",
		"QUIZ": "Quiz",
		"POST": "Publication",
		"POST_COMMENT": "Commentaire",
		"ORGANIZATION": "Etablissement",
		"GROUP": "Groupe",
		"USER": "Utilisateur",
		"privacy": {
			"warning": "Lorsque votre contenu est privé, il n’apparaît pas dans les résultats de la recherche. De plus, il doit être ajouté dans au moins une Classroom pour être publié.",
			"toggle": "Contenu privé."
		},
		"CAROUSEL": "Carousel"
	},
	"members": {
		"add": {
			"error": "Une erreur est survenue lors de l'ajout des membres."
		},
		"delete": {
			"error": "Une erreur est survenue lors de la suppression."
		},
		"search": {
			"placeholder": "Rechercher un membre..."
		},
		"role": {
			"CONTRIBUTOR": "Professeur",
			"ADMINISTRATOR": "Administrateur"
		},
		"CONTRIBUTOR": {
			"add": {
				"title": "Ajouter des professeurs",
				"button": "Ajouter des professeurs",
				"success": "Les professeurs ont bien été ajoutés."
			},
			"delete": {
				"success": "L'utilisateur a bien été retiré de la liste des professeurs.",
				"title": "Souhaitez-vous vraiment retirer ce professeur ? ",
				"self": {
					"title": "Souhaitez-vous vraiment ne plus être  professeur ?"
				}
			},
			"list": {
				"title": "Professeurs ({{count}})"
			}
		},
		"ADMINISTRATOR": {
			"add": {
				"title": "Ajouter des administrateurs",
				"button": "Ajouter des administrateurs",
				"success": "Les administrateurs ont bien été ajoutés."
			},
			"delete": {
				"success": "L'utilisateur a bien été retiré de la liste des administrateurs.",
				"title": "Souhaitez-vous vraiment retirer cet administrateur ? ",
				"self": {
					"title": "Souhaitez-vous vraiment ne plus être  administrateur ?"
				}
			},
			"list": {
				"title": "Administrateurs ({{count}})"
			}
		},
		"SUPER_ADMINISTRATOR": {
			"add": {
				"success": "Un nouveau Super Admin a été ajouté."
			}
		},
		"STUDENT": {
			"add": {
				"title": "Inviter des membres",
				"button": "Inviter des membres",
				"success": "Une invitation a été envoyée aux membres ajoutés."
			},
			"delete": {
				"success": "L'utilisateur a bien été retiré de la liste des membres.",
				"title": "Souhaitez-vous vraiment retirer ce membre ? "
			}
		},
		"SHAREROOM": {
			"MEMBER": {
				"list": {
					"title": "Apprenants ({{count}})"
				},
				"add": {
					"title": "Ajouter des apprenants",
					"button": "Ajouter des apprenants",
					"success": "Une invitation a été envoyée aux apprenants ajoutés."
				},
				"delete": {
					"success": "L'utilisateur a bien été retiré de la liste des apprenants.",
					"title": "Souhaitez-vous vraiment retirer cet apprenant ? "
				}
			},
			"ADMINISTRATOR": {
				"list": {
					"title": "Formateurs ({{count}})"
				},
				"add": {
					"title": "Ajouter des formateurs",
					"button": "Ajouter des formateurs",
					"success": "Une invitation a été envoyée aux formateurs ajoutés."
				},
				"delete": {
					"success": "L'utilisateur a bien été retiré de la liste des formateurs.",
					"title": "Souhaitez-vous vraiment retirer ce formateur ? "
				}
			}
		},
		"DISCUSSION_GROUP": {
			"MEMBER": {
				"list": {
					"title": "Membres ({{count}})"
				},
				"add": {
					"title": "Ajouter des membres",
					"button": "Ajouter des membres",
					"success": "Une invitation a été envoyée aux membres ajoutés."
				},
				"delete": {
					"success": "L'utilisateur a bien été retiré de la liste des membres.",
					"title": "Souhaitez-vous vraiment retirer ce membre ? "
				}
			},
			"ADMINISTRATOR": {
				"list": {
					"title": "Administrateurs ({{count}})"
				},
				"add": {
					"title": "Ajouter des administrateurs",
					"button": "Ajouter des administrateurs",
					"success": "Une invitation a été envoyée aux administrateurs ajoutés."
				},
				"delete": {
					"success": "L'utilisateur a bien été retiré de la liste des administrateurs.",
					"title": "Souhaitez-vous vraiment retirer cet administrateur ? "
				}
			}
		},
		"pending": {
			"list": {
				"title": "En attente ({{count}})",
				"accept": "Accepter",
				"reject": "Refuser ",
				"cancel_invitation": "Annuler l'invitation"
			}
		}
	},
	"quiz": {
		"title": "Quiz.",
		"editor": {
			"title": {
				"placeholder": "Ajouter un titre à votre quiz..."
			},
			"description": {
				"placeholder": "Ajouter une description ici..."
			},
			"category": {
				"placeholder": "Catégorie de votre quiz"
			},
			"level": {
				"placeholder": "Niveau requis du quiz"
			},
			"header": "Éditer un quiz",
			"new": {
				"header": "Créer un quiz"
			},
			"details": {
				"publication": "Publication",
				"settings": "Paramètres",
				"presentation": "Présentation"
			},
			"step": {
				"back": "Retour à l'édition"
			},
			"subtitle": {
				"EXERCISES": "Créer et éditer vos questions",
				"PREVIEW": "Résumé de votre quiz"
			},
			"save": {
				"published": "Enregistrer les modifications"
			},
			"archive": "Archiver le quiz",
			"delete": "Supprimer le quiz",
			"publish_modal": {
				"title": "Publier votre quiz",
				"submit": "Publier mon quiz"
			}
		},
		"exercise": {
			"delete": "Supprimer la question"
		},
		"save": {
			"draft": "Enregistrer le brouillon",
			"success": "Votre quiz a bien été sauvegardé."
		},
		"thumbnail": {
			"start": "Répondre au quiz ",
			"review": "Voir mes réponses",
			"participants": {
				"one": "Participant",
				"zero": "Aucun participant",
				"other": "Participants"
			},
			"badge_label": "Quiz"
		},
		"infos": {
			"category": "Dans : {{category}}",
			"participants": {
				"one": "Participant ({{count}})",
				"zero": "Participant",
				"other": "Participants ({{count}})"
			},
			"questions": "Questions"
		},
		"archive": {
			"success": "Votre quiz a bien été archivé."
		},
		"publish": {
			"success": "Votre quiz a bien été publié."
		},
		"details": {
			"title": "Détails"
		},
		"finished": {
			"title": "Quiz terminé !",
			"score": {
				"good": "Félicitations ! Vous avez obtenu",
				"bad": "Dommage... Vous n'avez obtenu que",
				"particpant": "{{name}} a obtenu",
				"value": "{{score}}% de bonnes réponses.",
				"infos": "En moyenne, les participants obtiennent",
				"average": "{{score}}% de réussite."
			},
			"share": "Partager mon résultat"
		},
		"visibility": {
			"PRIVATE": "Privé",
			"PUBLIC": "Public"
		},
		"shared": {
			"score": "J'ai obtenu {{score}}% de réussite"
		},
		"delete": {
			"title": "Souhaitez-vous vraiment supprimer ce contenu ?",
			"message": "Ce contenu ne sera plus visible par la communauté mais les publications liées ne seront pas supprimées."
		},
		"toast": {
			"delete": {
				"title": "Suppression",
				"message": "Votre quiz a bien été supprimé"
			}
		},
		"level": {
			"BEGINNER": "Facile",
			"INTERMEDIATE": "Moyen",
			"ADVANCED": "Difficile",
			"CLASSE_6EME": "6ème",
			"CLASSE_5EME": "5ème",
			"CLASSE_4EME": "4ème",
			"CLASSE_3EME": "3ème",
			"CLASSE_2NDE": "Seconde",
			"CLASSE_1ERE": "Première",
			"CLASSE_TERMINALE": "Terminale"
		}
	},
	"listing": {
		"more": "{{count}} de plus..."
	},
	"mobile": {
		"install_app": "Pensez à installer Jaangal sur votre écran d'accueil !"
	},
	"form": {
		"missing": "Ce champ est obligatoire, veuillez le renseigner !",
		"invalid": "Le format est invalide"
	},
	"language": {
		"FRENCH": "Français",
		"ENGLISH": "Anglais",
		"WOLOF": "Wolof",
		"SERERE": "Sérère",
		"PULAAR": "Pulaar",
		"DJOLEA": "Diola",
		"BAMBARA": "Bambara",
		"SONINKE": "Soninké",
		"BAOULE": "Baoulé",
		"BETE": "Bété",
		"SENOUFO": "Sénoufo",
		"DIOULA": "Dioula",
		"NOUCHI": "Nouchi"
	},
	"level": {
		"BEGINNER": "Débutant",
		"INTERMEDIATE": "Moyen",
		"ADVANCED": "Avancé",
		"none": "Pas de niveau",
		"CLASSE_6EME": "6ème",
		"CLASSE_5EME": "5ème",
		"CLASSE_4EME": "4ème",
		"CLASSE_3EME": "3ème",
		"CLASSE_2NDE": "Seconde",
		"CLASSE_1ERE": "Première",
		"CLASSE_TERMINALE": "Terminale"
	},
	"login": {
		"presentation": {
			"title": "Bienvenue sur",
			"shortRegisterTitle": "S'inscrire",
			"description": "Le réseau social éducatif, ouvert et gratuit.",
			"baseline": "Jaang ak Khaleyi 🎓"
		},
		"button": {
			"facebook": "Se connecter avec Facebook",
			"google": "Se connecter avec Google",
			"apple": "Se connecter avec Apple",
			"phone": "Se connecter avec Numéro ",
			"submit": "Se connecter",
			"register": "Je n'ai pas de compte"
		},
		"password": {
			"forgotten": "Mot de passe oublié ?"
		},
		"mail": "Ou par mail :",
		"social": "Connectez-vous facilement avec : ",
		"title": "Connexion",
		"card": {
			"title": "Nouveau sur Jaangal",
			"description": "Inscrivez-vous maintenant et élargissez votre monde !"
		}
	},
	"auth": {
		"social": {
			"login_after": "ou connectez-vous facilement avec : ",
			"register_after": "ou inscrivez-vous gratuitement avec : ",
			"login": "Connectez-vous facilement avec : ",
			"register": "Inscrivez-vous gratuitement avec : "
		},
		"error": {
			"credentials": "L'adresse mail ou le mot de passe est invalide",
			"exists": "L'adresse mail est déjà utilisée",
			"default": "Une erreur est survenue"
		},
		"cgu": {
			"modal": {
				"title": "Pour continuer, merci d'accepter nos Conditions Générales d'Utilisation"
			}
		},
		"modal": {
			"title": "Voir plus de contenu sur Jaangal en vous connectant :"
		},
		"login": {
			"title": "Content de vous revoir",
			"lead": "Connectez-vous pour accéder à votre espace.",
			"switchPrompt": "Pas encore de compte ?",
			"switchAction": "Inscrivez-vous"
		},
		"signup": {
			"switchPrompt": "Déjà un compte ?",
			"switchAction": "Connectez-vous",
			"identity": "Inscrivez-vous",
			"email": "Votre adresse email",
			"emailLead": "Un lien de confirmation vous sera envoyé par email.",
			"password": "Votre mot de passe",
			"passwordHelper": "Au moins 8 caractères, avec une lettre et un chiffre.",
			"passwordConfirm": "Confirmer le mot de passe",
			"passwordMismatch": "Les mots de passe ne correspondent pas.",
			"passwordWeak": "Le mot de passe doit contenir au moins 8 caractères, avec une lettre et un chiffre.",
			"continue": "Continuer",
			"submit": "Créez votre compte",
			"back": "Retour",
			"google": "Inscrivez-vous avec Google",
			"or": "ou",
			"phoneTab": "Téléphone",
			"emailTab": "Email",
			"phoneTitle": "Votre numéro",
			"phoneLead": "Un code de vérification vous sera envoyé par SMS.",
			"phoneInvalid": "Numéro de téléphone invalide."
		},
		"hero": {
			"title": "Apprendre et enseigner, ensemble.",
			"lead": "Rejoignez la communauté éducative : cours, ressources, entraide et offres partenaires, au même endroit.",
			"members": "+12k",
			"powered": "Powered by Orange"
		},
		"verify": {
			"title": "Vérifiez votre email",
			"lead": "Nous avons envoyé un lien de confirmation à {{email}}. Cliquez sur le lien pour activer votre compte.",
			"retry": "Renvoyer le lien"
		},
		"role": {
			"title": "Vous êtes ?",
			"lead": "Choisissez un profil pour continuer.",
			"learner": "Apprenant",
			"learnerLead": "J'apprends et je révise",
			"teacher": "Enseignant",
			"teacherLead": "Je partage et j'enseigne",
			"parent": "Parent",
			"parentLead": "J'accompagne un apprenant"
		},
		"names": {
			"title": "Votre nom",
			"lead": "Indiquez votre prénom et votre nom."
		},
		"phoneVerify": {
			"title": "Vérifiez votre numéro",
			"lead": "Entrez le code à 6 chiffres envoyé par SMS au {{phone}}.",
			"submit": "Vérifiez",
			"resendPrompt": "Vous n'avez rien reçu ?",
			"resend": "Renvoyer le code",
			"resendIn": "Renvoyer dans {{seconds}} s",
			"invalid": "Code invalide."
		}
	},
	"register": {
		"firstName": {
			"placeholder": "Prénom"
		},
		"lastName": {
			"placeholder": "Nom"
		},
		"button": {
			"submit": "S'inscrire",
			"login": "J'ai déjà un compte"
		},
		"cgu": {
			"accept": "J'ai lu et j'accepte les ",
			"link": "Conditions Générales d'Utilisation",
			"missing": "Veuillez accepter les conditions générales d'utilisation"
		},
		"title": "Inscription",
		"rejoin": "Rejoignez la communauté Jaangal !",
		"phonenumber": {
			"title": "Saisir votre numéro de téléphone ",
			"description": "Join the Jaangal community !",
			"placeholder": "Numéro de téléphone",
			"otp": {
				"description": "Veuillez saisir le code reçu sur le numéro qui se termine par {{lastTwoDigit}}.",
				"title": "Verification du numéro de téléphone saisi",
				"label": "Code de validation OTP"
			}
		},
		"social": {
			"login_after": "ou s'inscrire auprès de :"
		},
		"modal": {
			"title": "Voir plus de contenu Jaangal en créant un compte"
		}
	},
	"email": {
		"placeholder": "Adresse mail"
	},
	"password": {
		"weak": "Le mot de passe doit contenir au moins {{size}} caractères",
		"reset": {
			"success": "Votre nouveau mot de passe est prêt à être utilisé !",
			"title": "Modifier votre mot de passe"
		},
		"new": {
			"label": "Nouveau mot de passe"
		},
		"confirm": {
			"label": "Confirmer votre mot de passe"
		},
		"forgotten": {
			"title": "Récupérer votre mot de passe",
			"infos": "Renseigner votre adresse, nous vous enverrons un email de récupération.",
			"sent": "Nous vous avons envoyé un lien pour modifier votre mot de passe.",
			"button": "Envoyer"
		},
		"placeholder": "Mot de passe"
	},
	"navigation": {
		"root": "Accueil",
		"search": "Recherche",
		"editor": "Créer un cours",
		"profile": "Profil",
		"more": "Plus",
		"create": {
			"title": "Que voulez-vous créer ?",
			"post": {
				"title": "Post",
				"description": "Partagez du contenu avec votre communauté."
			},
			"quiz": {
				"title": "Quiz",
				"description": "Challengez vos amis et votre communauté."
			},
			"course": {
				"title": "Cours",
				"description": "Partagez un cours structuré avec votre communauté."
			},
			"discussion": {
				"title": "Groupe de discussion",
				"description": "Créez un espace d'échange public ou privé."
			},
			"shareroom": {
				"title": "Classroom",
				"description": "Créez un espace d'enseignement privé.",
				"soon": "Bientôt disponible."
			},
			"article": {
				"title": "Insight",
				"description": "Partagez une astuce, un tuto ou une actualité."
			}
		},
		"messages": "Messages"
	},
	"home": {
		"header": "Bonjour, {{name}}",
		"test_feedback": {
			"button": {
				"url": "http://feedback.jaangal.com"
			}
		},
		"new_content": {
			"incentive": "Voir les nouveaux contenus"
		}
	},
	"search": {
		"title": "Rechercher.",
		"input": {
			"placeholder": "Rechercher un cours, un profil..."
		},
		"tab": {
			"course": "Cours",
			"article": "Insights",
			"user": "Personnes",
			"organization": "Organisations"
		},
		"empty": "Aucun résultat ne correspond à la recherche",
		"count": "{{count}} resultat(s)",
		"COURSE": {
			"count": "{{count}} cours"
		},
		"ARTICLE": {
			"count": "{{count}} insights"
		},
		"QUIZ": {
			"count": "{{count}} quiz"
		},
		"USER": {
			"count": "{{count}} profils"
		},
		"COMPANY": {
			"count": "{{count}} pages entreprises"
		},
		"INSTITUTE": {
			"count": "{{count}} Établissements"
		},
		"SHAREROOM": {
			"count": "{{count}} classrooms"
		},
		"DISCUSSION": {
			"count": "{{count}} groupes de discussion"
		},
		"for": "pour",
		"category": "Catégorie",
		"carousel": {
			"suggestion_courses": "Suggestions de Cours",
			"suggestion_articles": "Suggestions d'Insights",
			"suggestion_quizzes": "Suggestions de Quiz",
			"suggestion_users": "Suggestions de Profils",
			"suggestion_organizations": "Suggestions d'Établissements",
			"suggestion_sharerooms": "Suggestions de Classrooms",
			"suggestion_discussions": "Suggestions de Groupes",
			"carousel": "Suggestions de Carrousels",
			"result_courses": "Cours ({{count}})",
			"result_articles": "Insights ({{count}})",
			"result_users": "Profils ({{count}})",
			"result_quizzes": "Quiz ({{count}})",
			"result_organizations": "Établissements ({{count}})",
			"result_sharerooms": "Classrooms ({{count}})",
			"result_discussions": "Groupes de discussion ({{count}})"
		},
		"CAROUSEL": {
			"count": "{{count}} carrousels"
		},
		"user": {
			"see_more_categories": "Voir plus"
		},
		"last": {
			"title": "Historique de recherche"
		},
		"filter": {
			"type": {
				"title": "Rechercher",
				"all": "Tous",
				"COURSE": "Cours",
				"ARTICLE": "Insights",
				"QUIZ": "Quiz",
				"USER": "Profils",
				"COMPANY": "Pages Entreprises",
				"INSTITUTE": "Établissements",
				"SHAREROOM": "Classrooms",
				"DISCUSSION": "Groupes de discussion",
				"CAROUSEL": "Carrousels"
			},
			"org_type": {
				"title": "Filtrer"
			},
			"user_country": {
				"title": "Pays de résidence"
			},
			"category": {
				"title": "Centres d'intérêt"
			},
			"level": {
				"title": "Niveau"
			},
			"language": {
				"title": "Langue"
			},
			"duration": {
				"title": "Durée",
				"UNKNOWN": "Inconnue",
				"MINUTES_0_TO_20": "1 - 20min",
				"MINUTES_20_TO_40": "20 - 40min",
				"MINUTES_40_TO_60": "40min - 1h",
				"MINUTES_MORE_THAN_60": "> 1h"
			},
			"provider": {
				"title": "Source"
			},
			"license": {
				"title": "Licence",
				"FREE": "Gratuite",
				"PREMIUM": "Payante"
			},
			"org_subtype": {
				"UNIVERSITY": "Université",
				"HIGH_SCHOOL": "École - Collège",
				"MIDDLE_SCHOOL": "École - Lycée",
				"PROFESSIONAL_TRAINING_CENTER": "Centre de Formation",
				"CERTIFICATION_CENTER": "Centre de Certification",
				"HIGHER_EDUCATION_INSTITUTE": "Institut Supérieure",
				"ACADEMY": "Académie",
				"RESEARCH_CENTER": "Centre de Recherches",
				"GENERAL_EDUCATION_INSTITUTE": "Institut d'Enseignement Général",
				"POLYTECHNIC_INSTITUTE": "Institut Polytechnique",
				"NATIONAL_HIGHER_SCHOOL": "École Nationale Supérieure",
				"ARTIST": "Artiste",
				"ASSOCIATION": "Association",
				"NON_PROFIT_ORGANIZATION": "Organisation à but non lucratif",
				"CHARITABLE_ORGANIZATION": "Association caritative",
				"COMMUNITY_ORGANIZATION": "Organisation communautaire",
				"INDIVIDUAL_COMPANY": "Société individuelle",
				"PUBLIC_COMPANY": "Société publique",
				"PRIVATE_COMPANY": "Société privée",
				"PUBLIC_FIGURE": "Personnalité publique"
			},
			"header": {
				"CONTENT": "CONTENU",
				"PAGES": "PAGES",
				"CHANNELS": "CANAUX"
			},
			"scoring": {
				"title": "Classement",
				"most-popular": "Les plus populaires"
			},
			"rating": {
				"title": "Note"
			}
		},
		"ORGANIZATION": {
			"count": "{{count}} organisations"
		}
	},
	"profile": {
		"tab": {
			"post": "Activité",
			"post_self": "Mon activité",
			"favorite": "Mes favoris",
			"course_self": "Mes cours",
			"course": "Cours",
			"content_self": "Mes contenus",
			"content": "Contenu",
			"groups": "Mes classrooms"
		},
		"content_self": {
			"courses": "Mes cours",
			"articles": "Mes insights",
			"quizzes": "Mes quiz",
			"carousels": "Mes carrousels"
		},
		"content": {
			"courses": "Cours",
			"articles": "Insights",
			"quizzes": "Quiz",
			"carousels": "Carrousels",
			"published": {
				"zero": "Aucun contenu publié",
				"one": "{{count}} contenu publié",
				"other": "{{count}} contenus publiés"
			},
			"PREMIUM": "Payante",
			"FREE": "Gratuite"
		},
		"course_self": {
			"empty": "Vous n'avez aucun cours de ce type",
			"empty_all": "Vous n'avez créé aucun cours."
		},
		"article_self": {
			"empty": "Vous n'avez aucun insight de ce type",
			"empty_all": "Vous n'avez créé aucun insight."
		},
		"quiz_self": {
			"empty": "Vous n'avez aucun quiz de ce type",
			"empty_all": "Vous n'avez créé aucun quiz."
		},
		"courses": {
			"empty": "{{user}} n'a publié aucun cours.",
			"published": {
				"zero": "Aucun cours publié",
				"one": "{{count}} cours publié",
				"other": "{{count}} cours publiés"
			}
		},
		"articles": {
			"empty": "{{user}} n'a publié aucun insight."
		},
		"quizzes": {
			"empty": "{{user}} n'a publié aucun quiz."
		},
		"favorite": {
			"empty": "Vous n’avez pas encore de contenus dans vos favoris. Epinglez ceux qui vous intéressent pour facilement les retrouver ici !"
		},
		"card": {
			"quick_edit": "Modifier mon profil",
			"description": {
				"add": "Ajouter un titre à votre profil",
				"cancel": "Annuler",
				"confirm": "Confirmer"
			},
			"follower": "Vous suit",
			"followers": "Abonnés",
			"followees": "Abonnements",
			"categories": {
				"see_more": " + Voir plus",
				"see_less": " - Voir moins"
			},
			"member_since": "Membre depuis ",
			"invite": {
				"title": "Inviter des amis à rejoindre Jaangal",
				"message": "Je t'invite à me rejoindre sur Jaangal",
				"action": {
					"send_invitation_button_label": "Inviter",
					"email_invalid_toast": "Email invalide",
					"email_invalid_example": "Veillez modifier l'adresse saisie (nom@exemple.com)",
					"instagram_tooltip": "Partager sur Instagram",
					"facebook_tooltip": "Partager sur Facebook",
					"twitter_tooltip": "Partager sur Twitter",
					"linkedin_tooltip": "Partager sur Linkedin",
					"whatsapp_tooltip": "Partager sur Whatsapp",
					"clipboard_tooltip": "Copier le lien",
					"copied_link": "Lien copié dans le presse-papiers"
				}
			},
			"asset_manager": "Ma médiathèque",
			"course": "Cours",
			"courses": "Cours",
			"content": {
				"at_most_one": "Contenu",
				"more_one": "Contenus"
			},
			"edit": {
				"NEW_PROFILE": "Ajuster ma photo",
				"NEW_FILTER": "Ajouter un filtre "
			},
			"message": "Contacter"
		},
		"action": {
			"follow": "Suivre",
			"unfollow": "Ne plus suivre",
			"follow_back": "Suivre en retour"
		},
		"suggest": {
			"title": "Profils à suivre.",
			"empty": "Aucune suggestion disponible pour le moment"
		},
		"menu": {
			"organizations": "Mes pages établissement",
			"settings": "Paramètres",
			"courses": "Mes contenus",
			"favorite": "Mes favoris",
			"discussions": "Mes groupes",
			"sharerooms": "Mes Classrooms",
			"backoffice": "Backoffice",
			"application": "Ma candidature",
			"experiences": "Mes expériences professionnelles.",
			"edit": "Modifier mon profil",
			"categories": "Mes centres d'intérêt"
		},
		"organizations": {
			"title": "Mes pages établissement.",
			"new": "Créer une page établissement",
			"empty": "Vous n'avez pas créé de page établissement"
		},
		"followers": {
			"title": "Abonnés ({{count}}).",
			"empty": "Ce profil n'a pas encore de comptes abonnés."
		},
		"followees": {
			"title": "Abonnements ({{count}}).",
			"empty": "Ce profil n'a pas encore d'abonnements."
		},
		"experiences": {
			"title": "Mes expériences professionnelles.",
			"new": "Ajouter une expérience",
			"label": "Expériences professionnelles.",
			"empty": "Cet utilisateur n'a pas ajouté d'expériences"
		},
		"academic_experiences": {
			"title": "Mes expériences scolaires.",
			"new": "Créer une expérience scolaire",
			"label": "Expériences scolaires.",
			"empty": "Cet utilisateur n'a pas ajouté d'expériences scolaires"
		},
		"professional_experiences": {
			"title": "Mes expériences professionnelles.",
			"new": "Créer une expérience professionnelle",
			"label": "Expériences professionnelles.",
			"empty": "Cet utilisateur n'a pas ajouté d'expériences professionnelles"
		},
		"edit": {
			"title": "Modifier mon profil.",
			"avatar": "Photo de profil",
			"crop": {
				"avatar": {
					"title": "Ajouter / Modifier ma photo de profil",
					"description": "Faites glisser pour repositionner la photo"
				},
				"error_message": "Il faut avoir une photo de profil standard {{size}} x {{size}}",
				"filter": {
					"no_filter": "#aucun"
				},
				"add_filter_from_another_profile": {
					"title": "Appliquer à ma photo de profil",
					"message": "Filtre bien appliqué sur votre profile."
				}
			},
			"banner": "Bannière",
			"name": "Nom complet",
			"firstName": "Prénom",
			"lastName": "Nom",
			"country": "Pays",
			"description": "Titre du profil",
			"presentation": "Présentation"
		},
		"save": {
			"error": "Une erreur est survenue lors de la sauvegarde"
		},
		"categories": {
			"title": "Mes centres d'intérêt"
		},
		"complete": {
			"label": "Complétez votre profil",
			"phone": {
				"title": "Ajoutez votre téléphone",
				"lead": "Indispensable pour accéder aux offres partenaires.",
				"placeholder": "77 123 45 67",
				"invalid": "Entrez un numéro valide (9 chiffres minimum).",
				"empty": "Renseignez votre numéro ou passez cette étape."
			},
			"language": {
				"title": "Langue de la plateforme",
				"lead": "Choisissez la langue d'affichage de Jaangal."
			},
			"country": {
				"title": "Votre pays",
				"lead": "Indiquez votre pays de résidence."
			},
			"birth": {
				"title": "Votre date de naissance",
				"lead": "Elle nous aide à adapter les contenus proposés."
			},
			"gender": {
				"title": "Vous êtes ?",
				"lead": "Pour mieux personnaliser votre expérience.",
				"other": "Autre"
			},
			"interests": {
				"title": "Vos centres d'intérêt",
				"lead": "Choisissez les sujets qui vous parlent."
			},
			"follows": {
				"title": "Profils à suivre",
				"lead": "Suivez des membres pour enrichir votre fil."
			},
			"skip": "Passez",
			"finish": "Terminez",
			"thanks": {
				"title": "Merci, c'est complété !",
				"lead": "Votre profil est à jour. Profitez pleinement de Jaangal : contenus personnalisés et offres partenaires débloqués.",
				"action": "Accédez à mon fil"
			}
		},
		"self": {
			"button": "Voir mon profil",
			"shareroom_premium": {
				"empty_all": "Vous n'êtes dans aucune classroom payante"
			},
			"shareroom_free": {
				"empty_all": "Vous n'êtes dans aucune classroom"
			},
			"shareroom_free_member": {
				"empty": "Vous n'êtes apprenant dans aucune classroom "
			},
			"shareroom_premium_member": {
				"empty": "Vous n'êtes apprenant dans aucune classroom payante "
			},
			"shareroom_free_administrator": {
				"empty": "Vous n'êtes formateur dans aucune classroom"
			},
			"shareroom_premium_administrator": {
				"empty": "Vous n'êtes formateur dans aucune classroom payante"
			}
		},
		"experiences_self": {
			"empty": "Vous n'avez pas ajouté d'expériences"
		},
		"academic_experiences_self": {
			"empty": "Vous n'avez pas ajouté d'expériences scolaires"
		},
		"professional_experiences_self": {
			"empty": "Vous n'avez pas ajouté d'expériences professionnelles"
		},
		"auth": {
			"incentive": "Accédez au profil complet de {{name}} en vous connectant sur Jaangal"
		},
		"selector": {
			"placeholder": "Choisissez un profil"
		},
		"carousel_self": {
			"empty_all": "Vous n'avez publié aucun carrousel."
		},
		"carousels": {
			"empty": "{{user}} n'a publié aucun carrousel."
		},
		"application": {
			"popin-success": {
				"label": "Félicitations !",
				"message": "Vous avez complété avec succès votre candidature au programme. Suivez vos notifications pour connaître en temps réel le statut de votre candidature.",
				"share-profile": {
					"label": "Partagez votre profil et inviter vos amis à voter pour vous !"
				}
			}
		},
		"shareroom_premium": {
			"empty_all": "{{name}} n'est dans aucune classroom payante"
		},
		"shareroom_free": {
			"empty_all": "{{name}} n'est dans aucune classroom"
		},
		"shareroom_free_member": {
			"empty": "{{name}} n'est apprenant dans aucune classroom "
		},
		"shareroom_premium_member": {
			"empty": "{{name}} n'est apprenant dans aucune classroom payante "
		},
		"shareroom_free_administrator": {
			"empty": "{{name}} n'est formateur dans aucune classroom"
		},
		"shareroom_premium_administrator": {
			"empty": "{{name}} n'est formateur dans aucune classroom payante"
		}
	},
	"{{user}} hasn't created any article": {
		"": "Cours"
	},
	"backoffice": {
		"page": {
			"title": "Backoffice"
		},
		"tab": {
			"REPORTS": "Signalements",
			"APPLICATIONS": "Canditatures",
			"communication": "Communication"
		},
		"communication": {
			"title": "Communication",
			"description": "Modifiez ici l'image à afficher pour communiquer avec les utilisateurs et utilisatrices de Jaangal.",
			"url": {
				"label": "Lien de l'image (facultatif)",
				"placeholder": "https://example.com"
			},
			"submit": "Enregistrer"
		},
		"application": {
			"fullname": "Nom complet",
			"residence": "Pays",
			"degree": "Niveau",
			"program": "Programme",
			"status": "Statut",
			"filter": {
				"reset": "Réinitialiser",
				"candidat": "Candidat"
			}
		}
	},
	"experience": {
		"create": {
			"title": "Nouvelle expérience"
		},
		"academic": {
			"create": {
				"title": "Nouvelle expérience scolaire"
			},
			"name": {
				"title": "Nom de l'établissement*",
				"placeholder": "ex : Lycée Seydina Limamoulaye"
			},
			"diploma": {
				"title": "Niveau de diplôme",
				"placeholder": "ex : CFEE, BFEM..."
			},
			"domain": {
				"title": "Série / Filière",
				"placeholder": "ex : S1, S2, G..."
			},
			"title": {
				"title": "Intitulé de la Filière*",
				"placeholder": "ex : Mathématiques et Sciences physiques ..."
			},
			"current": {
				"check": "Je suis actuellement cette formation"
			},
			"info": {
				"current": "Formation actuelle"
			}
		},
		"professional": {
			"create": {
				"title": "Nouvelle expérience professionnelle"
			},
			"name": {
				"title": "Nom de l'établissement*",
				"placeholder": "Nom de l'entreprise"
			},
			"title": {
				"title": "Titre du poste*",
				"placeholder": "L’intitulé de votre poste"
			},
			"current": {
				"check": "Ceci est mon poste actuel."
			},
			"info": {
				"current": "Poste actuel"
			}
		},
		"edit": {
			"title": "Modifier une expérience"
		},
		"name": {
			"title": "Nom de l'établissement"
		},
		"country": {
			"title": "Pays",
			"placeholder": "Lieu de l'expérience"
		},
		"title": {
			"placeholder": "Titre du poste"
		},
		"start": {
			"label": "Date de début"
		},
		"end": {
			"label": "Date de fin"
		},
		"current": {
			"check": "Ceci est mon poste actuel"
		},
		"teacher": {
			"check": "Poste de professeur/coach/formateur"
		},
		"save": {
			"success": "Les modifications ont bien été enregistrées."
		},
		"info": {
			"teacher": "Formateur"
		},
		"delete": {
			"title": "Souhaitez-vous vraiment supprimer cette expérience ?"
		}
	},
	"feed": {
		"empty": "{{user}} n'a pas encore publié de contenu.",
		"self": {
			"empty": "Retrouvez ici vos publications et partages avec votre communauté Jaangal. Lancez-vous et créez votre premier post !"
		},
		"incentive": {
			"info": "Retrouvez ici vos publications et partages avec votre communauté Jaangal. ",
			"button": "Créer mon premier post"
		},
		"suggestions": {
			"title": "Découvrez aussi",
			"users": "Profils à découvrir",
			"courses": "Cours pouvant vous intéresser",
			"organizations": "Organisations à suivre",
			"quizzes": "Quiz pouvant vous intéresser",
			"groups": "Groupes de discussion pouvant vous intéresser",
			"sharerooms": "Classrooms pouvant vous intéresser"
		}
	},
	"tag": {
		"ALL": "Tout",
		"ARTICLE": "Insights",
		"COURSE": "Cours",
		"CAROUSEL": "Carrousels",
		"FREE": "Gratuite",
		"PREMIUM": "Payante"
	},
	"course": {
		"action": {
			"edit": "Éditer",
			"share_detail": "Partager sur mon profil"
		},
		"header": "Cours",
		"infos": {
			"date": "Dernière modification {{date}}",
			"date_published": "Publié {{date}}",
			"category": "Dans : ",
			"subcategory": "Sous-catégorie :"
		},
		"editor": {
			"header": "Éditer un cours",
			"new": {
				"header": "Créer un cours"
			},
			"image": {
				"upload": "Ajouter une image"
			},
			"title": {
				"placeholder": "Donner un titre à votre cours...",
				"missing": "Cours sans titre..."
			},
			"description": {
				"placeholder": "Ajouter une description détaillée... A qui s'adresse ce cours ? Que va apprendre l'apprenant ?",
				"label": "Description"
			},
			"save": {
				"draft": "Enregistrer en brouillon",
				"published": "Enregistrer les modifications",
				"default": "Enregistrer les modifications",
				"preview": "Prévisualiser"
			},
			"preview": "Prévisualiser",
			"required_data": "Les champs marqués d’un astérisque (*) doivent être renseignés pour la publication. En brouillon, seul le titre est obligatoire.",
			"publish": "Publier le cours",
			"archive": "Archiver le cours",
			"delete": "Supprimer le cours",
			"section": {
				"add": "Ajouter un élément",
				"video": {
					"new": "Vidéo",
					"placeholder": "Collez ici votre lien YouTube"
				},
				"youtube": {
					"new": "Lien YouTube",
					"placeholder": "Collez ici votre lien Youtube"
				},
				"text": {
					"new": "Texte",
					"placeholder": "Écrivez votre texte ici... (sélectionnez le texte pour les options de mise en forme)"
				},
				"image": {
					"new": "Image"
				},
				"document": {
					"new": "PDF"
				},
				"qcm": {
					"new": "Question à choix multiples"
				},
				"subtitle": {
					"new": "Sous-titre",
					"placeholder": "Ajoutez un sous-titre"
				},
				"attachment": {
					"new": "Pièce jointe",
					"placeholder": "Titre de la pièce jointe"
				}
			},
			"qcm": {
				"add": "Nouvelle question",
				"title": {
					"placeholder": "Éditer la question...*"
				},
				"answer": {
					"add": "Ajouter une réponse",
					"placeholder": "Réponse {{index}}*"
				},
				"choose_answer": "Choisissez la bonne réponse",
				"comment": {
					"title": "Explications",
					"placeholder": "Développer ici les éléments de la réponse.\nCe texte ne sera visible par l’utilisateur qu'après avoir répondu à la question."
				},
				"title_missing": "Le titre de la question est obligatoire.",
				"answer_empty": "Certaines réponses n'ont pas de texte."
			},
			"banner": {
				"edit": "Modifier la photo de couverture"
			},
			"introduction": {
				"add": "Ajouter une vidéo de présentation",
				"edit": "Modifier la vidéo de présentation"
			},
			"chapter": {
				"placeholder": "Ajouter un titre à votre chapitre",
				"add": "Ajouter un nouveau chapitre"
			},
			"language": {
				"placeholder": "Langue du cours"
			},
			"level": {
				"placeholder": "Niveau requis du cours*"
			},
			"publisher": {
				"label": "Publier en tant que",
				"keep_ownership": "Être crédité en tant qu'auteur du cours."
			},
			"details": {
				"publication": "Publication",
				"settings": "Paramètres",
				"presentation": "Présentation du cours",
				"shareroom": "Ajouter à mes Classrooms"
			},
			"step": {
				"back": "Retour à l'édition"
			},
			"publish_modal": {
				"title": "Publier votre cours",
				"confirm": "Êtes-vous sûr d'avoir terminé l'édition ? Prêt à publier ? ",
				"share": "Générer un post automatique pour prévenir vos abonnés",
				"submit": "Publier mon cours",
				"share_placeholder": "Ajouter un message personnalisé...",
				"authorship": "Je certifie être l’auteur(e) de ce cours ou en détenir les droits de publication"
			}
		},
		"delete": {
			"title": "Voulez-vous vraiment supprimer ce contenu ?",
			"message": "Ce contenu ne sera plus visible par la communauté mais les publications liées ne seront pas supprimées."
		},
		"author": {
			"label": "Auteur du cours",
			"link": "Voir le profil"
		},
		"institute": {
			"link": "Voir l'établissement"
		},
		"company": {
			"link": "Voir l'entreprise"
		},
		"toolbar": {
			"feedback": "Je donne mon avis",
			"feedback_edit": "Éditer mon avis",
			"start": "Commencer",
			"external": {
				"UDEMY": "Voir sur Udemy",
				"COURSERA": "Voir sur Coursera"
			},
			"share": "Partager"
		},
		"feedback": {
			"infos": "Donner votre avis sur le cours",
			"stars": {
				"1": "Décevant",
				"2": "Moyen",
				"3": "Bien",
				"4": "Super",
				"5": "Parfait !"
			},
			"placeholder": "Votre commentaire (optionnel)",
			"date": "Posté le {{date}}"
		},
		"feedbacks": {
			"empty": "Il n'y a pas encore d'avis sur ce cours.",
			"title": "Avis"
		},
		"section": {
			"qcm": {
				"title": "Questionnaire à choix multiples",
				"number": "Question {{index}}"
			},
			"attachment": {
				"title": "Fichier .{{type}}",
				"download": "Télécharger"
			}
		},
		"status": {
			"PUBLISHED": "Publié",
			"DRAFT": "Brouillon",
			"ARCHIVED": "Archivé",
			"ALL": "Statut"
		},
		"toast": {
			"save": {
				"title": "Sauvegarde",
				"message": "Le cours a bien été sauvegardé.",
				"error": "Une erreur est survenue lors de la sauvegarde."
			},
			"publish": {
				"message": "Votre cours a bien été publié."
			},
			"archive": {
				"message": "Votre cours a bien été archivé."
			},
			"delete": {
				"title": "Suppression",
				"message": "Votre cours a bien été supprimé."
			}
		},
		"suggest": {
			"title": "Suggestions de cours.",
			"no_results": "Aucune suggestion disponible pour le moment"
		},
		"content": {
			"back": "Retour sur la présentation",
			"quick_access": "Sommaire"
		},
		"chapter": {
			"prefix": "Chapitre {{index}} : "
		},
		"thumbnail": {
			"from": "Par",
			"you": "vous",
			"badge_label": "Cours"
		},
		"chapters": {
			"summary": "Contenu du cours"
		},
		"workspaces": {
			"add": "Ajouter à une Classroom",
			"success": "Le cours a été ajouté aux espaces séléctionnés.",
			"error": "Une erreur est survenue lors de l'ajout du cours.",
			"count": {
				"zero": "{{count}} espace.",
				"one": "{{count}} espace.",
				"other": "{{count}} espaces."
			}
		},
		"auth": {
			"incentive": "Accéder à ce cours en vous connectant à Jaangal. "
		},
		"bookmark_title": "Ajouter à mes favoris"
	},
	"article": {
		"action": {
			"edit": "Éditer",
			"share_detail": "Partager sur mon profil"
		},
		"header": "Insights.",
		"infos": {
			"date": "Dernière modification {{date}}",
			"date_published": "Publié {{date}}",
			"category": "Dans : ",
			"subcategory": "Sous-catégorie :"
		},
		"editor": {
			"header": "Éditer un insight.",
			"new": {
				"header": "Créer un insight."
			},
			"image": {
				"upload": "Ajouter une image"
			},
			"title": {
				"placeholder": "Donner un titre à votre insight...",
				"missing": "Insight sans titre"
			},
			"description": {
				"placeholder": "Ajouter une description détaillée de l'insight...",
				"label": "Description"
			},
			"save": {
				"draft": "Enregistrer en brouillon",
				"published": "Enregistrer les modifications",
				"default": "Enregistrer les modifications",
				"preview": "Enregistrer et prévisualiser"
			},
			"preview": "Prévisualiser",
			"required_data": "Les champs marqués d’un astérisque (*) doivent être renseignés pour la publication. En brouillon, seul le titre est obligatoire.",
			"publish": "Publier l'insight",
			"archive": "Archiver l'insight",
			"delete": "Supprimer l'insight",
			"section": {
				"add": "Ajouter un élément",
				"video": {
					"new": "Vidéo",
					"placeholder": "Collez ici votre lien YouTube"
				},
				"youtube": {
					"new": "Lien YouTube",
					"placeholder": "Collez ici votre lien Youtube"
				},
				"text": {
					"new": "Texte",
					"placeholder": "Écrivez votre texte ici... (sélectionnez le texte pour les options de mise en forme)"
				},
				"image": {
					"new": "Image"
				},
				"document": {
					"new": "PDF"
				},
				"qcm": {
					"new": "Question à choix multiples"
				},
				"subtitle": {
					"new": "Sous-titre",
					"placeholder": "Ajouter un sous-titre"
				},
				"attachment": {
					"new": "Pièce jointe",
					"placeholder": "Titre de la pièce jointe"
				}
			},
			"qcm": {
				"add": "Nouvelle question",
				"title": {
					"placeholder": "Éditer la question...*"
				},
				"answer": {
					"add": "Ajouter une réponse",
					"placeholder": "Réponse {{index}}*"
				},
				"choose_answer": "Choisissez la bonne réponse",
				"comment": {
					"title": "Explications",
					"placeholder": "Développer ici les éléments de la réponse.\nCe texte ne sera visible par l’utilisateur qu'après avoir répondu à la question."
				},
				"title_missing": "Le titre de la question est obligatoire.",
				"answer_empty": "Certaines réponses n'ont pas de texte."
			},
			"banner": {
				"edit": "Modifier la photo de couverture"
			},
			"language": {
				"placeholder": "Langue"
			},
			"publisher": {
				"label": "Publier en tant que",
				"keep_ownership": "Être crédité en tant qu'auteur de l'insight."
			},
			"details": {
				"news": {
					"label": "Actualités à la une"
				},
				"publication": "Publication",
				"settings": "Paramètres",
				"presentation": "Photo de couverture de l'insight",
				"shareroom": "Ajouter à mes Classrooms"
			},
			"step": {
				"back": "Retour à l'édition"
			},
			"publish_modal": {
				"title": "Publier votre insight",
				"confirm": "Êtes-vous sûr d'avoir terminé l'édition ? Prêt à publier ? ",
				"share": "Générer un post automatique sur le feed.",
				"submit": "Publier mon insight",
				"share_placeholder": "Ajouter un message à votre post...",
				"authorship": "Je certifie être l’auteur(e) de cet insight ou en détenir les droits de publication"
			}
		},
		"delete": {
			"title": "Souhaitez-vous vraiment supprimer ce contenu ?",
			"message": "Ce contenu ne sera plus visible par la communauté mais les publications liées ne seront pas supprimées."
		},
		"author": {
			"label": "Auteur de l'insight.",
			"link": "Voir le profil"
		},
		"institute": {
			"link": "Voir l'établissement"
		},
		"company": {
			"link": "Voir l'entreprise"
		},
		"toolbar": {
			"feedback": "Je donne mon avis",
			"feedback_edit": "Éditer mon avis",
			"start": "Commencer",
			"share": "Partager"
		},
		"feedback": {
			"infos": "Donner votre avis sur l'insight",
			"stars": {
				"1": "Décevant",
				"2": "Passable",
				"3": "Bien",
				"4": "Super",
				"5": "Parfait !"
			},
			"placeholder": "Votre commentaire",
			"created_date": "Posté le {{date}}",
			"updated_date": "Edité le {{date}}",
			"created_hour": "à {{hour}}"
		},
		"feedbacks": {
			"empty": "Il n'y a pas encore de commentaire sur cet insight",
			"title": "Avis"
		},
		"section": {
			"qcm": {
				"title": "Questionnaire à choix multiples",
				"number": "Question {{index}}"
			},
			"attachment": {
				"title": "Fichier .{{type}}",
				"download": "Télécharger"
			}
		},
		"status": {
			"PUBLISHED": "Publié",
			"DRAFT": "Brouillon",
			"ARCHIVED": "Archivé",
			"ALL": "Statut"
		},
		"toast": {
			"save": {
				"title": "Sauvegarde",
				"message": "L'insight a bien été sauvegardé.",
				"error": "Une erreur est survenue lors de la sauvegarde."
			},
			"publish": {
				"message": "Votre insight a bien été publié."
			},
			"archive": {
				"message": "Votre insight a bien été archivé."
			},
			"delete": {
				"title": "Suppression",
				"message": "Votre insight a bien été supprimé."
			}
		},
		"suggest": {
			"title": "Deniers insights.",
			"no_results": "Aucune suggestion disponible pour le moment"
		},
		"content": {
			"back": "Retour sur la présentation",
			"quick_access": "Sommaire"
		},
		"chapter": {
			"prefix": "Chapitre {{index}} : "
		},
		"thumbnail": {
			"from": "Par",
			"you": "vous",
			"badge_label": "Insight"
		},
		"chapters": {
			"summary": "Contenu de l'insight"
		},
		"workspaces": {
			"add": "Ajouter à une Classroom",
			"success": "L'insight a été ajouté aux espaces séléctionnés",
			"error": "Une erreur est survenue lors de l'ajout de l'insight.",
			"count": {
				"zero": "{{count}} espace.",
				"one": "{{count}} espace.",
				"other": "{{count}} espaces."
			}
		},
		"auth": {
			"incentive": "Accéder à plus d'insight en vous connectant à Jaangal, c'est gratuit !"
		},
		"comments": "Commentaires",
		"add_comment": "Ajouter un commentaire",
		"suggestions": "Suggestions d'insight ",
		"news": "News d'insight ",
		"delete_feedback": {
			"title": "Êtes-vous sûr de vouloir supprimer votre commentaire ?"
		}
	},
	"settings": {
		"menu": {
			"title": "Paramètres.",
			"notifications": "Gestion des notifications",
			"system": "Préférences générales",
			"confidentiality": "Confidentialité",
			"more": "Plus",
			"login": "Paramètres de connexion"
		},
		"notifications": {
			"title": "Gestion des notifications.",
			"header": {
				"type": "Type de notifications",
				"email": "Email",
				"app_notification": "Notifications"
			}
		},
		"system": {
			"title": "Régler vos préférences générales.",
			"content": {
				"language": {
					"title": "Langue"
				},
				"currency": {
					"title": "Devise par défaut"
				},
				"email": {
					"title": "Email"
				}
			}
		},
		"more": {
			"title": "Plus."
		},
		"login": {
			"title": "Mettez à jour  vos paramètres de connexion  ",
			"phonenumber": {
				"label": "Numéro de téléphone",
				"add": "Ajouter  mon numéro de téléphone",
				"update": "Modifier mon numéro de téléphone"
			}
		},
		"save": {
			"success": "Paramètres sauvegardés !"
		},
		"change": {
			"email": {
				"label": "Modifier votre adresse email",
				"infos": "Renseigner votre adresse email, nous vous enverrons un lien de modification.",
				"placeholder": "Saisir votre adresse email actuelle",
				"link": {
					"title": "Modifier mon email d'authentification "
				},
				"message": "Nous vous avons envoyé un lien pour modifier votre email.",
				"new": {
					"placeholder": "Saisir votre nouvelle adresse email",
					"confirm": {
						"placeholder": "Saisir à nouveau la nouvelle adresse email"
					}
				},
				"success": "Votre nouvelle adresse email est prête à être utilisée !"
			}
		},
		"delete": {
			"account": {
				"label": "Etes-vous bien sûr de vouloir supprimer votre compte Jaangal ?",
				"success": "Demande bien prise en compte",
				"link": {
					"title": "Demander la suppression de mon compte"
				}
			}
		},
		"currency": {
			"USD": "Dollars US",
			"EUR": "Euro",
			"CHF": "Franc Suisse",
			"XOF": "FCFA",
			"placeholder": "Choisissez une devise par défaut"
		},
		"link_phonenumber": {
			"title": "Ajouter votre numéro d’authentification",
			"label": "Saisir votre numéro de téléphone",
			"otp": {
				"title": "Vérification du numéro de téléphone saisi",
				"label": "Code de validation OTP",
				"message": "Veuillez saisir le code reçu sur le numéro",
				"toast": {
					"success": {
						"message": "Votre numéro de téléphone a bien été enregistré !"
					},
					"error": {
						"message": "Le code OTP que vous avez saisi est erroné. Réessayez svp !"
					}
				}
			},
			"toast": {
				"success": {
					"message": "Un code OTP vous sera envoyé par SMS "
				},
				"error": {
					"message": "Un erreur est survenue. Réessayez svp !"
				}
			}
		},
		"modify_phonenumber": {
			"title": "Modifier votre numéro de télépone d’authentification",
			"otp": {
				"toast": {
					"success": {
						"message": "Votre numéro de téléphone a bien été modifié !"
					}
				}
			}
		},
		"modal": {
			"update_phonenumber": {
				"title": "Saisir votre numéro de téléphone actuel"
			}
		},
		"update_phonenumber": {
			"toast": {
				"error": {
					"message": "Le numéro de téléphone saisi ne correspond pas à votre numéro de téléphone actuel"
				}
			},
			"title": "Modifier mon numéro de téléphone d'authentification",
			"label": "Veuillez saisir votre nouveau numéro de téléphone"
		}
	},
	"setting": {
		"notifications": {
			"content": {
				"followups": {
					"title": "Suivi",
					"description": "Un utilisateur a commencé à me suivre."
				},
				"mentions": {
					"title": "Mentions",
					"description": "Un utilisateur m’a identifié dans une publication ou un commentaire."
				},
				"sharing": {
					"title": "Contenu partagé",
					"description": "Un utilisateur a partagé un contenu que j’ai créé ou dans lequel je suis identifié."
				},
				"likes": {
					"title": "Likes",
					"description": "Un utilisateur a liké un contenu que j’ai créé ou dans lequel je suis identifié."
				},
				"comments": {
					"title": "Commentaires",
					"description": "Un utilisateur a commenté un contenu que j’ai créé ou dans lequel je suis identifié."
				},
				"publications": {
					"title": "Publications",
					"description": "Un utilisateur que je suis a publié un contenu éducatif."
				},
				"feedbacks": {
					"title": "Avis",
					"description": "Un utilisateur a donné son avis sur un de mes contenus éducatifs."
				},
				"participations": {
					"title": "Participations",
					"description": "Un utilisateur a participé à l’un de Mes quiz."
				},
				"associations": {
					"title": "Associations",
					"description": "Un utilisateur m’a associé à une page établissement."
				},
				"organizations": {
					"title": "Associations",
					"description": "Un utilisateur m’a associé à une page établissement."
				},
				"deletions": {
					"title": "Contenu supprimé.",
					"description": "Un utilisateur a supprimé un contenu éducatif lié une page établissement à laquelle je suis associé."
				},
				"sharerooms": {
					"title": "Classrooms",
					"description": "Un utilisateur m'invite à rejoindre une Classroom."
				},
				"groups": {
					"title": "Groupes de discussion",
					"description": "Un utilisateur m'invite à rejoindre un groupe de discussion."
				},
				"system": {
					"title": "Système",
					"description": "Un de mes contenus a été supprimé par un administrateur."
				},
				"instructive": {
					"title": "Contenu Instructif",
					"description": "Un utilisateur a marqué un contenu que j'ai créé comme instructif"
				},
				"live_course": {
					"title": "Cours live",
					"description": "Une classroom ou une page à laquelle je suis abonné lance un cours live"
				}
			}
		}
	},
	"organization": {
		"create": {
			"title": "Créer une page établissement.",
			"button": "Créer",
			"switch": {
				"title": "Quel type de page souhaitez-vous créer ?"
			},
			"institute": {
				"title": "Établissement scolaire\nou de formation",
				"description": "Créez une page pour votre établissement scolaire. Partagez des informations sur vos enseignements et mettez en avant des contenus pédagogiques."
			},
			"company": {
				"title": "Entreprise",
				"description": "Présentez votre entreprise sur Jaangal, faites-vous connaître auprès des jeunes talents présents sur la plateforme et diffusez vos offres d'emploi et de stage."
			}
		},
		"edit": {
			"title": "Éditer une page établissement."
		},
		"logo": {
			"add": "Ajouter un logo",
			"edit": "Editer le logo"
		},
		"banner": {
			"add": "Ajouter une bannière",
			"edit": "Editer la bannière"
		},
		"save": {
			"button": "Sauvegarder",
			"error": "Une erreur est survenue lors de la sauvegarde.",
			"success": "Les modifications ont bien été enregistrées."
		},
		"form": {
			"creationDate": {
				"title": "Année de création"
			},
			"country": {
				"title": "Pays*",
				"placeholder": "Choisir le pays"
			},
			"instituteType": {
				"title": "Type d'établissement*",
				"placeholder": "Choisir le type d'établissement"
			},
			"companyType": {
				"title": "Type d'entreprise",
				"placeholder": "Choisir le type d'entreprise"
			},
			"primaryName": {
				"title": "Nom de l'établissement*",
				"placeholder": "Ajouter le nom de l'établissement"
			},
			"description": {
				"title": "Description succincte*",
				"placeholder": "Ajouter une description succincte"
			},
			"email": {
				"title": "Adresse mail de contact*",
				"placeholder": "Ajouter l'adresse mail"
			},
			"address": {
				"title": "Adresse postale",
				"placeholder": "Ajouter l'adresse postale"
			},
			"phoneNumber": {
				"title": "Téléphone",
				"placeholder": "Ajouter le téléphone"
			},
			"webSite": {
				"title": "Site web",
				"placeholder": "Ajouter l'url du site web"
			}
		},
		"report": {
			"mail": "report@jaangal.com",
			"button": "Signaler la page"
		},
		"delete": {
			"title": "Souhaitez-vous vraiment supprimer cette organisation ?",
			"infos": "Les utilisateurs ne pourront plus consulter cette organisation sur Jaangal. Cette action est irréversible."
		},
		"toast": {
			"delete": {
				"message": "L'organisation a bien été supprimée."
			}
		},
		"switch": {
			"message": "Je vois actuellement la page en tant que",
			"admin": "Administrateur",
			"user": "Visiteur"
		},
		"tab": {
			"activity": "Activités",
			"presentation": "Présentation",
			"courses": "Cours",
			"content": "Contenu",
			"community": "Communauté",
			"tracks": "Filières",
			"shareroom": "Groupes et Classrooms",
			"events": "Evénements"
		},
		"tracks": {
			"empty": "L'établissement n'a pas ajouté de filières.",
			"new": "Ajouter une filière",
			"edit": "Éditer une fillière",
			"presentation": {
				"owner": {
					"description": "Présentez les filières et parcours proposés par votre établissement."
				},
				"member": {
					"description": "Aucune filière n’a encore été renseignée sur cette page."
				}
			}
		},
		"track": {
			"create": {
				"success": "La filière a bien été créée."
			},
			"save": {
				"success": "La filière a bien été sauvegardée."
			},
			"level": {
				"placeholder": "Niveau*"
			},
			"name": {
				"placeholder": "Nom*"
			},
			"description": {
				"placeholder": "Description"
			},
			"levels": {
				"label": "Diplômes proposés",
				"placeholder": "ex : Baccalauréat S1, T2, etc…"
			},
			"presentation": "Présentation",
			"logo": {
				"add": "Ajouter un logo.",
				"edit": "Editer le logo"
			}
		},
		"details": {
			"mobile_title": "Informations",
			"year_of_creation": {
				"label": "Créé en {{year}}"
			},
			"categories": {
				"institute": {
					"add": "Ajouter des domaines de formation."
				},
				"company": {
					"add": "Ajouter des domaines d'activité."
				},
				"edit": "Éditer"
			}
		},
		"categories": {
			"institute": {
				"title": "Domaines de formation"
			},
			"company": {
				"title": "Domaines d'activité"
			}
		},
		"type": {
			"UNIVERSITY": "Université",
			"HIGH_SCHOOL": "École - Collège",
			"MIDDLE_SCHOOL": "École - Lycée",
			"PROFESSIONAL_TRAINING_CENTER": "Centre de Formation Professionnelle",
			"CERTIFICATION_CENTER": "Centre de Certification",
			"HIGHER_EDUCATION_INSTITUTE": "Institut Supérieur",
			"ACADEMY": "Académie",
			"RESEARCH_CENTER": "Centre de Recherches",
			"GENERAL_EDUCATION_INSTITUTE": "Institut d'Enseignement Général",
			"POLYTECHNIC_INSTITUTE": "Institut Polytechnique",
			"NATIONAL_HIGHER_SCHOOL": "École Nationale Supérieure",
			"ARTIST": "Artiste",
			"ASSOCIATION": "Association",
			"NON_PROFIT_ORGANIZATION": "Organisation à but non lucratif",
			"CHARITABLE_ORGANIZATION": "Association caritative",
			"COMMUNITY_ORGANIZATION": "Organisation communautaire",
			"INDIVIDUAL_COMPANY": "Société individuelle",
			"PUBLIC_COMPANY": "Société publique",
			"PRIVATE_COMPANY": "Société privée",
			"PUBLIC_FIGURE": "Personnalité publique"
		},
		"header": {
			"quick_edit": "Modifier ma page",
			"follow": "S’abonner",
			"unfollow": "Se désabonner"
		},
		"presentation": {
			"title": "Présentation",
			"empty": "Cette organisation n'a pas encore de description",
			"button": "Ajouter une présentation",
			"placeholder": "Ajouter une présentation à votre page"
		},
		"pictures": {
			"title": "Photos de l'établissement",
			"add": "Ajouter des photos",
			"presentation": {
				"owner": {
					"description": "Ajoutez des photos de votre établissement pour aider les étudiants à mieux se projeter."
				},
				"member": {
					"description": "Aucune photo de présentation n’a encore été ajoutée sur cette page."
				}
			}
		},
		"accreditations": {
			"title": "Les accréditations",
			"empty": "Aucune accréditation n'a été ajoutée.",
			"new": "Ajouter une accréditation",
			"edit": "Modifier une accréditation",
			"presentation": {
				"owner": {
					"description": "Renseignez les accréditations et reconnaissances dont bénéficie votre établissement."
				},
				"member": {
					"description": "Aucune accréditation n’a encore été renseignée sur cette page."
				}
			}
		},
		"accreditation": {
			"logo": {
				"edit": "Editer le logo",
				"add": "Ajouter un logo*"
			},
			"name": {
				"placeholder": "Nom*"
			},
			"reference": {
				"placeholder": "Numéro de référence*",
				"view": "Référence n°{{reference}}"
			},
			"description": {
				"placeholder": "Ajouter une description"
			},
			"date": {
				"label": "Année d'obtention",
				"view": "Obtenue en {{year}}"
			},
			"save": {
				"success": "L'accréditation a bien été sauvegardée."
			},
			"delete": {
				"success": "L'accréditation a bien été supprimée."
			}
		},
		"teachers": {
			"list": {
				"title": "Nos enseignants. ({{count}})",
				"empty": "Cette organisation n'a pas encore ajouté d'enseignant."
			},
			"add": {
				"title": "Ajouter des professeurs.",
				"button": "Ajouter des professeurs",
				"success": "Les professeurs ont bien été ajoutés."
			},
			"more": "Voir plus",
			"delete": {
				"success": "L'utilisateur a bien été retiré de la liste des professeurs.",
				"title": "Voulez-vous vraiment retirer ce professeur ?"
			}
		},
		"detailed_teachers": {
			"list": {
				"title": "Professeurs ({{count}})"
			}
		},
		"join": {
			"title": "Rejoignez {{name}} !",
			"button": "Contactez-nous !"
		},
		"course": {
			"incentive": "Créer un cours pour {{institute}}"
		},
		"quizze": {
			"incentive": "Créer un quizz pour {{institute}}"
		},
		"article": {
			"incentive": "Créer un article pour {{institute}}"
		},
		"diploma": {
			"edit": "Éditer un diplôme",
			"new": "Créer un diplôme",
			"title": {
				"placeholder": "Nom de la formation"
			},
			"description": {
				"placeholder": "Description de la formation"
			},
			"duration": {
				"placeholder": "Durée de la formation",
				"label": "Durée"
			},
			"type": {
				"INITIAL": "Formation initiale",
				"CONTINUOUS": "Formation continue",
				"ALTERNATING": "Formation en alternance",
				"label": "Type"
			},
			"mode": {
				"FACE_TO_FACE": "Présentiel",
				"DISTANCE": "À distance",
				"MIXED": "Mixte",
				"label": "Mode"
			},
			"delete": {
				"success": "La formation a bien été supprimée."
			},
			"save": {
				"success": "La formation a bien été sauvegardée."
			},
			"create": {
				"success": "La formation a bien été créée."
			}
		},
		"members": {
			"search": {
				"placeholder": "Rechercher un membre..."
			},
			"role": {
				"CONTRIBUTOR": "Professeur",
				"ADMINISTRATOR": "Administrateur"
			},
			"CONTRIBUTOR": {
				"list": {
					"title": "Professeurs ({{count}})"
				}
			},
			"ADMINISTRATOR": {
				"list": {
					"title": "Administrateurs ({{count}})"
				}
			},
			"add": {
				"error": "Une erreur est survenue lors de l'ajout des membres."
			},
			"delete": {
				"error": "Une erreur est survenue lors de la suppression d'un membre."
			}
		},
		"CONTRIBUTOR": {
			"add": {
				"title": "Ajouter des professeurs.",
				"button": "Ajouter des professeurs.",
				"success": "Les professeurs ont bien été ajoutés."
			},
			"delete": {
				"success": "L'utilisateur a bien été retiré de la liste des professeurs.",
				"title": "Voulez-vous vraiment retirer ce professeur ?",
				"self": {
					"title": "Voulez-vous vraiment vous retirer des professeurs ?"
				}
			}
		},
		"ADMINISTRATOR": {
			"add": {
				"title": "Ajouter des administrateurs.",
				"button": "Ajouter des administrateurs.",
				"success": "Les administrateurs ont bien été ajoutés."
			},
			"delete": {
				"success": "L'utilisateur a bien été retiré de la liste des administrateurs.",
				"title": "Voulez-vous vraiment retirer cet administrateur ?",
				"self": {
					"title": "Voulez-vous vraiment vous retirer des administrateurs ?"
				}
			}
		},
		"auth": {
			"incentive": "Accédez à toutes les informations de {{name}} en vous connectant à Jaangal. "
		},
		"transfer_ownership": {
			"button": "Céder la propriété de la page",
			"title": "Céder la propriété de la page.",
			"selection": "Veuillez choisir lequel des administrateurs reprendra la propriété de la page.",
			"confirmation": "Êtes-vous sûr de vouloir céder votre rôle de Super Admin à cet utilisateur ?"
		},
		"distinction": {
			"title": "Distinction",
			"empty": "Aucune distinction n'a été ajoutée.",
			"new": "Ajouter une distinction",
			"edit": "Modifier une distinction",
			"logo": {
				"edit": "Editer le logo",
				"add": "Ajouter un logo*"
			},
			"name": {
				"placeholder": "Nom*"
			},
			"reference": {
				"placeholder": "Numéro de référence*",
				"view": "Référence n°{{reference}}"
			},
			"description": {
				"placeholder": "Ajouter une description"
			},
			"date": {
				"label": "Année d'obtention",
				"view": "Obtenue en {{year}}"
			},
			"save": {
				"success": "La distinction a bien été sauvegardée."
			},
			"delete": {
				"success": "La distinction a bien été supprimée."
			}
		},
		"about": {
			"presentation": {
				"owner": {
					"description": "Présentez votre établissement, sa philosophie pédagogique, ses valeurs et ses infrastructures."
				},
				"member": {
					"description": "Aucune présentation n’a encore été ajoutée sur cette page."
				}
			}
		}
	},
	"track": {
		"level": {
			"bachelor": "Licence",
			"master": "Master",
			"phd": "PHD",
			"mba": "MBA",
			"baccalaureat": "Baccalauréat",
			"bepc": "BEPC"
		}
	},
	"onboarding": {
		"hello": "Bonjour ",
		"verify": {
			"infos": "Afin de vérifier votre adresse email, nous avons envoyé un lien de vérification à l'adresse {{email}}. Veuillez cliquer sur le lien qu'il contient pour continuer l'inscription. ",
			"retry": "Renvoyer l'email",
			"sent": "Un nouvel e-mail de confirmation a été envoyé."
		},
		"infos": {
			"presentation": "Afin de profiter au maximum de l’expérience Jaangal, nous vous suggérons de nous en dire un peu plus sur vous. "
		},
		"next": "Suivant",
		"gender": {
			"male": "Homme",
			"female": "Femme",
			"other": "Autre / Ne pas spécifier"
		},
		"birth": {
			"placeholder": "Année de naissance"
		},
		"language": {
			"FRENCH": "Français",
			"ENGLISH": "Anglais",
			"placeholder": "Langue préférée"
		},
		"country": {
			"placeholder": "Pays de résidence"
		},
		"categories": {
			"title": "Séléctionner les sujets qui vous intéressent.",
			"minimum": "({{min}} minimum)"
		},
		"follows": {
			"title": "Suivre des profils inspirants.",
			"minimum": "({{min}} minimum)"
		},
		"end": "Commencer"
	},
	"verify": {
		"title": "Vérification de l'adresse mail.",
		"error": {
			"expired": "Le code utilisé a expiré.",
			"invalid": "Le code utilisé est invalide.",
			"disabled": "Le compte utilisateur a été désactivé.",
			"not_found": "Le compte utilisateur n'existe pas."
		},
		"success": "L'e-mail a bien été vérifié, vous pouvez maintenant vous connecter."
	},
	"modal": {
		"publish": {
			"title": "Publier votre cours",
			"confirm": "Êtes-vous sûr d'avoir terminé l'édition, prêt à la publier ?",
			"share": "Générer un post automatique pour prévenir vos followers",
			"submit": "Publier mon cours",
			"share_placeholder": "Ajouter un message personnalisé..."
		}
	},
	"more": {
		"page": {
			"faq": "FAQ",
			"feedback": "Feedback",
			"cgu": "CGU",
			"policy": "Politique de confidentialité",
			"notice": "Mentions légales",
			"about": "A propos",
			"support": "Support"
		},
		"copyright": "© {{currentYear}} Jaangal",
		"about": "En savoir plus sur Jaangal"
	},
	"upload": {
		"error": {
			"format": "Le format de l'image sélectionnée n'est pas accepté.",
			"size": "Le fichier est trop volumineux (Taille maximale : 250Mo).",
			"size_small": {
				"title": "Fichier trop volumineux.",
				"message": "Pour les fichiers de plus de 100Mo, pensez à utiliser votre médiathèque."
			},
			"pending": "Un téléchargement est déjà en cours",
			"unknown": "Une erreur est survenue lors du téléchargement"
		},
		"canceled": "Le téléchargement a été annulé"
	},
	"notification": {
		"title": "Notifications",
		"follower": "a commencé à vous suivre",
		"read_all": "Marquer tout comme lu.",
		"post": {
			"new": {
				"male": "vous a mentionné(e)  dans une publication.",
				"female": "vous a mentionné(e)  dans une publication.",
				"other": "vous a mentionné(e) dans une publication",
				"organization": "a mentionné votre organisation {{name}}"
			},
			"self": {
				"like": "a liké votre publication.",
				"share": "a partagé votre publication.",
				"comment": "a commenté votre publication."
			},
			"mention": {
				"like": {
					"male": "a liké une publication dans laquelle vous êtes mentionnée.",
					"female": "a liké une publication dans laquelle vous êtes mentionnée.",
					"other": "a liké une publication dans laquelle vous êtes mentionnée.",
					"organization": "a liké une publication dans laquelle votre organisation {{name}} est mentionnée."
				},
				"share": {
					"male": "a partagé une publication dans laquelle vous êtes mentionné.",
					"female": "a partagé une publication dans laquelle vous êtes mentionnée.",
					"other": "a partagé une publication dans laquelle vous êtes mentionné(e).",
					"organization": "a partagé une publication dans laquelle votre organisation {{name}} est mentionnée."
				},
				"comment": {
					"male": "a commenté une publication dans laquelle vous êtes mentionné.",
					"female": "a commenté une publication dans laquelle vous êtes mentionné.",
					"other": "a commenté une publication dans laquelle vous êtes mentionné(e).",
					"organization": "a commenté une publication dans laquelle votre organisation {{name}} est mentionnée."
				}
			}
		},
		"comment": {
			"male": "vous a identifié dans un commentaire.",
			"female": "vous a mentionnédans un commentaire.",
			"other": "vous a mentionné(e) dans un commentaire.",
			"organization": "a mentionnévotre organisation {{name}} dans un commentaire."
		},
		"course": {
			"new": "a publié un nouveau cours.",
			"feedback": {
				"new": "a laissé un avis sur votre cours."
			},
			"deleted": "a supprimé le cours {{course}}."
		},
		"empty": "Vous n'avez aucune notification",
		"institute": {
			"linked": {
				"male": "Vous avez été ajouté comme professeur à la page {{institute}}",
				"female": "Vous avez été ajoutée comme professeur à la page {{institute}}",
				"other": "Vous avez été ajouté(e) comme professeur à la page {{institute}}",
				"CONTRIBUTOR": {
					"male": "Vous avez été ajouté comme professeur à la page {{institute}}. ",
					"female": "Vous avez été ajoutée comme professeur à la page {{institute}}.",
					"other": "Vous avez été ajouté(e) comme professeur à la page {{institute}}."
				},
				"ADMINISTRATOR": {
					"male": "Vous avez été ajouté comme administrateur à la page {{institute}}.",
					"female": "Vous avez été ajoutée comme administratrice à la page {{institute}}.",
					"other": "Vous avez été ajouté(e) comme admin à la page {{institute}}."
				},
				"SUPER_ADMINISTRATOR": {
					"male": "Vous avez été ajouté comme super administrateur de la page {{institute}}.",
					"female": "Vous avez été ajoutée comme super administratrice de la page {{institute}}.",
					"other": "Vous avez été ajouté(e) comme super admin de la page {{institute}}."
				}
			}
		},
		"quiz": {
			"new": "a publié un nouveau quiz.",
			"participation": "a participé à votre quiz.",
			"deleted": "a supprimé le quiz ."
		},
		"group": {
			"invited": {
				"male": "vous a invité à rejoindre",
				"female": "vous a invité à rejoindre",
				"other": "vous a invité à rejoindre"
			},
			"accepted": "a accepté l'invitation à rejoindre"
		},
		"discussion": {
			"removed": {
				"male": "vous a retiré du groupe",
				"female": "vous a retirée du groupe",
				"other": "vous a retiré(e) du groupe"
			},
			"request": "a demandé à rejoindre le groupe",
			"granted": "a accepté votre demande à rejoindre le groupe"
		},
		"shareroom": {
			"removed": {
				"male": "vous a retiré(e) de la classroom",
				"female": "vous a retiré(e) de la classroom",
				"other": "vous a retiré(e) de la classroom"
			},
			"subscription": "vient de s'abonner à votre classroom",
			"request": "a demandé à rejoindre la classroom",
			"granted": "a accepté votre demande à rejoindre la classroom"
		},
		"moderated": "Votre {{content}} a été modéré par un administrateur pour la raison suivante :",
		"organization": {
			"deleted": "a supprimé l'organisation",
			"mention": "a identifié votre organisation {{name}}."
		},
		"article": {
			"new": "a publié un nouvel insight",
			"feedback": {
				"new": "a commenté votre insight"
			},
			"deleted": "a supprimé l'insight {{insight}}."
		},
		"carousel": {
			"new": "a publié un nouveau carrousel",
			"instructive": "a trouvé instructif votre carrousel"
		},
		"live": {
			"live": "vient de démarrer un cours live",
			"planned": "a programmé un cours live"
		},
		"share_application": {
			"new": "a publié sa vidéo d'application OMAT"
		}
	},
	"tooltip": {
		"home": "Accueil",
		"editor": "Créer un cours",
		"feed": "Accueil"
	},
	"toast": {
		"success": "Succès"
	},
	"app": {
		"register": {
			"connectwith": "Ou connectez vous facilement avec :",
			"firstName": "Votre prénom",
			"lastName": "Votre nom",
			"password": "Mot de passe"
		},
		"firebase": {
			"invalid-custom-token": "Token invalide",
			"invalid-credential": "Identifiants invalides",
			"user-disabled": "Utilisateur désactivé",
			"email-already-in-use": "Adresse e-mail déjà utilisée",
			"invalid-email": "Email invalide",
			"wrong-password": "Mot de passe invalide",
			"user-not-found": "Utilisateur introuvable",
			"account-exists-with-different-credential": "Cet utilisateur existe avec des identifiants différents",
			"invalid-user-token": "Token utilisateur expiré",
			"network-request-failed": "Erreur de connexion",
			"user-mismatch": "Les utilisateurs ne concordent pas",
			"credential-already-in-use": "Identifiants déjà utilisé",
			"weak-password": "Mot de passe faible",
			"invalid-recipient-email": "Adresse email de réception invalide",
			"missing-app-credential": "Veuillez renseigner vos identifiants",
			"invalid-app-credential": "L'identifiant renseigné est invalide",
			"code-expired": "Le code a expiré",
			"quota-exceeded": "Vous avez atteint votre quota",
			"app-not-verified": "Application non vérifiée",
			"popup-closed-by-user": "Tentative de connexion annulée",
			"internal-error": "Erreur interne",
			"passwordsDoNotMatch": "Les deux mots de passe ne concordent pas",
			"googleAuthPlayServices": "Les services Google Play indisponibles",
			"googleAuthInProgress": "Connexion google en cours",
			"too-many-requests": "Attendez un moment avant de réessayer de vous connecter svp"
		}
	},
	"banner": {
		"description": "Jaangal est désormais disponible sur Google Play Store.\t",
		"link": "Téléchargez",
		"text": "l’app mobile dès maintenant !"
	},
	"program": {
		"page": {
			"sub_title": "AFRICAN TALENTS CHALLENGE",
			"full_title": "One Million African Talents ",
			"title": "ONE MILLION",
			"baseline": {
				"title": "Révèle ton talent et décroche une bourse d’étude supérieure"
			},
			"challenge": {
				"title": "Mets en scène ton talent avec une vidéo-story de 30 secondes"
			},
			"description": {
				"p1": "Jaangal te permet de candidater pour obtenir une bourse d’étude de l’Université allemande International University of Applied Sciences pour des programmes Bachelor, Master et MBA dispensés 100% en ligne. ",
				"p2": "Pour participer, mets en scène ton talent dans une vidéo de moins d’une minute. Pour valider ta participation tu devra compléter les étapes de candidature du programme One Million African Talents. "
			},
			"about": {
				"title": "A propos du Programme",
				"description": {
					"p1": "Le programme One Million African Talents est la concrétisation d’un ambitieux projet qui offre la possibilité à des jeunes africains d’avoir accès à une éducation de qualité qui répond aux normes des meilleures universités et centres de formation du monde.",
					"p2": "En partenariat avec Study Access Alliance, Jaangal fournira des bourses d'études pour des diplômes universitaires en ligne de l'IU International University of Applied Sciences à ceux qui, autrement, n'auraient pas la possibilité financière d'étudier.\n\nAvec plus de 75 000 étudiants, l'université internationale IU est la plus grande université d'Allemagne et celle qui connaît la plus forte croissance en Europe. Cette université accréditée par l'État propose le plus large éventail de diplômes au monde, en mettant l'accent sur la technologie et la gestion. Des bourses d'études seront disponibles pour les diplômes en ligne de type Bachelor, Master et MBA, qui s'obtiennent en 1 à 3 ans.",
					"p3": "Le lancement de la première partie du programme One Million African Talents sera marqué par l’octroiement de bourses d’études à 100 000 étudiants africains qui bénéficieront de formations certifiantes en ligne sur une période de 5 ans."
				}
			},
			"partner": {
				"title": "Rendre les études en ligne encore plus accessibles "
			},
			"partner-saa": {
				"description": {
					"p1": "Nous voulons combler le fossé de l’enseignement supérieur en Afrique avec une éducation en ligne de haute qualité, hautement évolutive, avec un maximum d’employabilité et de valeur pour le financement afin d’autonomiser les gens et de soutenir le développement durable.",
					"p2": "Nous croyons que Study Access Alliance Africa permettra aux étudiants de grandir et nous sommes convaincus que l’initiative a le potentiel de façonner l’enseignement supérieur et de soutenir le développement économique durable en Afrique."
				}
			},
			"partner-iu": {
				"description": {
					"p1": "IU International University of Applied Science, avec plus de 10 ans d’expérience en tant que la plus grande université à distance d’Allemagne, vous aide à trouver le diplôme d’apprentissage à distance qui correspond à vos ambitions professionnelles.",
					"p2": "Nos programmes sont reconnus et accrédités dans le monde entier, et sont offerts entièrement en ligne. Vous pouvez rejoindre nos programmes d’apprentissage à distance de n’importe où, à tout moment, tout en obtenant le soutien dont vous avez besoin de nos experts en carrière et en études. Construisez vos études pour qu’elles correspondent à votre horaire : vous pouvez étudier à temps plein ou à temps partiel."
				}
			},
			"tablist": {
				"title": "Programmes",
				"bachelor": {
					"label": "Bachelor"
				},
				"master": {
					"label": "Master"
				},
				"mba": {
					"label": "MBA"
				},
				"all_program": {
					"label": "Bachelor, Master & MBA"
				},
				"program": {
					"label": "Découvrez tous les programmes de IU International University of Applied Science"
				}
			},
			"moustache": {
				"title": "One Million African Talents est ouvert aux candidatures du 11 Août au 30 Novembre !",
				"link": {
					"title": "Obtenez votre bourse d'études"
				}
			},
			"button": {
				"howto": {
					"label": "Comment participer ?",
					"to": "https://drive.google.com/file/d/1FH3lWzI_rj0fbHXv7wZb5bwkD-I11dLV/view"
				},
				"apply": {
					"label": "Postuler maintenant"
				},
				"viewall": {
					"label": "Voir les programmes"
				}
			}
		},
		"insight": {
			"scholarships-count": {
				"label": "100 000"
			},
			"countries-count": {
				"label": 54
			},
			"cursus-count": {
				"label": "50{{caracter}}"
			},
			"courses-count": {
				"label": "100{{caracter}}"
			},
			"scholarships": {
				"label": "bourses"
			},
			"countries": {
				"label": "pays africains"
			},
			"cursus": {
				"label": "cursus disponibles"
			},
			"courses": {
				"label": "cours en ligne"
			}
		},
		"poppin": {
			"basics": {
				"label": "Avant de postuler",
				"description": "Vous allez postuler en vue de bénéficier d’une bourse pour étudier en ligne et obtenir un diplôme au sein d’une grande université Européenne. Voici quelques prérequis à prendre en considération : ",
				"l1": "Vérifiez que vous pouvez justifier de votre identité, votre adresse et votre ville de résidence",
				"l2": "Vous êtes en mesure de justifier d’un niveau de connaissance de la langue anglaise suffisant pour suivre des cours dispensés en anglais",
				"l3": "Préparez votre CV tabulaire (en anglais)",
				"l4": "Vous avez à disposition vos relevés de notes et votre dernier diplôme obtenu (pour en présenter des copies)"
			},
			"eligible": {
				"label": "Êtes-vous éligible ?",
				"description": "Pour être éligible au programme OMAT vous devez remplir les conditions ci-dessous :",
				"l1": "Avoir la nationalité d’un pays d’Afrique",
				"l2": "Etre résident d’un pays d’Afrique",
				"l3": "Ne pas avoir la possibilité de financer soi-même les études supérieures dont font l’objet la demande de bourse"
			},
			"reminder": {
				"label": "Rappel",
				"description": "Les bourses sont pour des études à temps plein et ne couvrent que la période standard d'études, vous pourrez choisir une date de début où vous etes vraiment disponible pour étudier ~ 30h/semaine !"
			},
			"rules": {
				"label1": "J’accepte le",
				"label2": " règlement du challenge"
			},
			"news": {
				"label": "J’accepte de recevoir de l'acualité sur le programme"
			},
			"button": {
				"signin": {
					"label": "Se connecter et postuler"
				}
			}
		},
		"pub": {
			"title": "Participez au challenge pour obtenir une bourse d'étude !"
		},
		"sheet": {
			"card": {
				"title": "Bienvenue sur votre dossier de candidature,",
				"admin-title": "Bienvenue sur le dossier de candidature de,"
			}
		}
	},
	"application": {
		"space": {
			"label": "Espace de candidature."
		},
		"status": {
			"label": "Statut",
			"NOT_COMPLETED": "Non complété",
			"COMPLETED": "Terminé",
			"PENDING_VALIDATION": "Validation en cours",
			"APPROVED": "Bourse accordée",
			"DECLINED": "En attente de validation",
			"SCHOLARSHIP_GRANTED": "Bourse accordée",
			"STUDY_IN_PROGRESS": "Formation en cours",
			"STUDY_FINISHED": "Fin de la formation"
		},
		"form": {
			"label": "Formulaire de candidature",
			"description": "Veuillez remplir le formulaire ci-dessous, tous les champs sont obligatoires. ",
			"firstname": {
				"label": "Votre prénom",
				"placeholder": "Ajouter votre prénom"
			},
			"familyname": {
				"label": "Votre nom de famille",
				"placeholder": "Ajouter votre nom de famille"
			},
			"date_birth": {
				"label": "Date de naissance",
				"placeholder": "Ajouter votre date de naissance"
			},
			"country_residence": {
				"label": "Pays de résidence",
				"placeholder": "Choisissez votre pays de résidence",
				"tooltip": "Les bourses d’études sont réservées aux résidents africain"
			},
			"nationality": {
				"label": "Nationalité",
				"placeholder": "Choisissez votre pays",
				"tooltip": "Les bourses d’études sont réservées aux nationalités des pays africains"
			},
			"phone_number": {
				"label": "Numéro téléphone WhatsApp",
				"placeholder": "+221770000000'"
			},
			"email": {
				"label": "Email",
				"placeholder": "Ajouter votre adresse email",
				"tooltip": "Nous utiliserons l'adresse de votre compte Jaangal"
			},
			"degree_level": {
				"label": "Niveau de formation",
				"placeholder": "Choisir un niveau de diplôme",
				"tooltip": "Vérifiez votre élligibilité avant de choisir le niveau d'étude"
			},
			"degree_program": {
				"label": "Programme d'étude",
				"placeholder": "Choisir un programme d'étude",
				"tooltip": "Détails sur iu.org"
			},
			"credit_points": {
				"label": "Crédits ECTS",
				"placeholder": "Crédits ECTS",
				"tooltip": "Selon les programmes, vous devrez choisir entre 2 ou 3 formules"
			},
			"desired_date": {
				"label": "Date de démarrage souhaitée",
				"placeholder": "Choisir une date de démarrage",
				"tooltip": "Choisissez une date adaptée à votre agenda, il s'agit d'études à temps plein"
			},
			"identity": {
				"label": "Pièce d'identité (CNI ou Passeport)",
				"placeholder": "Chargez votre pièce d'identité ici",
				"tooltip": "Carte Nationale d'Identité ou Passeport"
			},
			"residency": {
				"label": "Justificatif de résidence",
				"placeholder": "Chargez votre justificatif de résidence ici",
				"tooltip": "Justificatif de résidence délivré par votre poste de police, lettre officielle, facture Internet ou équivalent"
			},
			"diploma": {
				"label": "Copie de votre plus haut diplôme obtenu",
				"placeholder": "Chargez ici votre diplôme le plus élevé"
			},
			"transcript_diploma": {
				"label": "Transcription du diplôme (traduction anglaise certifiée)",
				"placeholder": "Chargez ici la transcription de votre diplôme",
				"tooltip": "Uniquement pour les diplômes non rédigés en anglais"
			},
			"work_certificate": {
				"label": "Certificat de travail pour certains Master’s/MBA",
				"placeholder": "Chargez ici votre certificat de travail"
			},
			"work_certificate_template_file": {
				"label": "Télécharger le modèle du certificat de travail"
			},
			"related_degrees_file": {
				"label": "Voir la liste des diplômes concernés"
			},
			"resume": {
				"label": "CV en anglais",
				"placeholder": "Charger ici votre CV rédigé en anglais",
				"tooltip": "Votre CV doit être rédigé obligatoirement en anglais"
			},
			"english_certificate": {
				"checkbox": "Je certifie avoir au moins un niveau B2 en anglais",
				"placeholder": "Ajouter un certificat de niveau d'anglais (optionnel)",
				"label": "Niveau d'anglais",
				"tooltip": "Si vous n’avez pas de certificat de niveau d’anglais, vous pourrez avoir à suivre une formation gratuite d’anglais avant de pouvoir démarrer le programme."
			},
			"financial_declaration": {
				"label": "Déclaration sur l'honneur de besoin financier",
				"placeholder": "Chargez votre déclaration sur l'honneur ici",
				"tooltip": "Vous devez utiliser le modèle à télécharger, le signer et le charger ici "
			},
			"video_story": {
				"infos": {
					"FORMAT_AND_QUALITY": {
						"title": "A - FORMAT ET QUALITÉ",
						"INFO_ONE": "La vidéo-story doit être au format paysage intégral 16:9 pour une durée comprise entre 15 secondes et 1 minute. Elle ne doit pas dépasser la taille de 250 Mb.",
						"INFO_TWO": "Les candidats doivent trouver le meilleur décor possible (intérieur ou extérieur) pour une bonne qualité de sa vidéo-story et utiliser l’éclairage naturel et s’assurer d’avoir une bonne qualité sonore",
						"INFO_THREE": "Activer son micro",
						"INFO_FOURTH": "Éviter les échos et tout bruit environnant"
					},
					"CONTENT": {
						"title": "B - CONTENU",
						"INFO_ONE": "Le candidat doit se présenter en déclinant son identité et son niveau d’étude.",
						"INFO_TWO": "Il doit aussi parler de son projet d’étude et professionnel",
						"INFO_THREE": "Il doit ensuite parler de sa motivation",
						"INFO_FOURTH": "Et enfin inviter sa communauté à voter pour lui",
						"INFO_FIFTH": "Les langues retenues sont le français et l’anglais"
					}
				},
				"label": "Vidéo story",
				"placeholder": "Charger votre vidéo story ici",
				"tooltip": "Vérifiez le format et le poids de votre vidéo"
			},
			"template_file": {
				"label": "Télécharger le modèle à signer"
			},
			"video_sample": {
				"label": "Voir un exemple"
			},
			"upload_file": {
				"requirement": "Votre fichier ne doit pas dépasser {{fileSize}}Mb et doit être dans les formats suivants"
			},
			"button_next": {
				"label": "Suivant"
			},
			"button_previous": {
				"label": "Précedent"
			},
			"button_finish": {
				"label": "Terminer"
			},
			"button_save": {
				"label": "Enregistrer ma progression"
			},
			"reminder": "Rappel"
		},
		"step": {
			"study_choices": {
				"title": "Votre choix d'études",
				"description": "Dans cette section vous allez donner votre choix d’études parmi la liste proposées par l’université IU. \nUn seul choix est possible, prenez le temps de bien vous documenter afin de demander le cursus qui correspond le mieux à votre profil et à vos attentes."
			},
			"personal_informations": {
				"title": "Vos informations personnelles",
				"description": "Veuillez remplir le formulaire ci-dessous, tous les champs sont obligatoires."
			},
			"upload_documents": {
				"title": "Vos justificatifs",
				"description": "Pour compléter votre candidature, vous devez charger dans cet espace l’ensemble des documents justificatifs nécessaires. \nVous pouvez le faire en plusieurs fois, n’oubliez pas d’enregistrer votre progression. "
			},
			"video_story": {
				"title": "Votre vidéo story",
				"description": "Enfin, vous allez maintenant télécharger la vidéo story de votre talent ici."
			},
			"summary": {
				"title": "Résumé",
				"description": "Fiche de candidature"
			}
		},
		"sheet": {
			"diploma": {
				"label": "Plus recent diplôme obtenu"
			},
			"transcript_diploma": {
				"label": "Transcription du diplôme"
			},
			"work_certificate": {
				"label": "Certificat de travail"
			},
			"fullname": {
				"label": "Nom"
			},
			"birthday": {
				"label": "Naissance"
			},
			"country": {
				"label": "Pays"
			},
			"desired_date": {
				"label": "Démarrage souhaité"
			},
			"level": {
				"label": "Niveau"
			},
			"program": {
				"label": "Programme"
			},
			"card": {
				"title": "One Million African Talents",
				"name_label": "Bienvenue sur votre espace de candidature"
			},
			"english_certificate": {
				"label": "Certificat de niveau d'anglais"
			}
		},
		"success": {
			"label": "Félicitations !",
			"message": "Vous avez complété avec succès votre espace de candidature. Surveillez vos notifications pour connaître le statut de votre candidature.",
			"share_link": {
				"label": "Partagez votre profil pour inviter vos amis à voter pour vous !"
			},
			"share_social": {
				"label": "Partager sur {{name}}"
			}
		},
		"succes": {
			"copy_link": {
				"label": "Copier le lien"
			},
			"share_video": {
				"title": "Générer un post automatiquement pour inviter vos abonnés à vous soutenir",
				"button": "publier ma vidéo",
				"toast": "Votre vidéo a bien été publié."
			}
		},
		"toast": {
			"save": {
				"title": "Sauvegardé",
				"message": "Votre progression a bien été sauvegardée",
				"error": "Une erreur est survenue lors de la sauvegarde"
			}
		},
		"save_button": "Terminer",
		"save_draft_button": "Enregistrer ma progression",
		"button": {
			"start_title": "Postuler maintenent",
			"continous_title": "Continuer",
			"terminate_title": "Voir ma candidature"
		},
		"partnership": {
			"label": "En partenariat avec"
		}
	},
	"vote": {
		"baseline": {
			"label": "Je suis un talent africain"
		},
		"counter": {
			"single": {
				"label": "{{total}} vote"
			},
			"label": "{{total}} votes"
		},
		"button": {
			"share": {
				"label": "Partager"
			},
			"vote": {
				"label": "Voter"
			}
		},
		"share": {
			"my-profile": {
				"message": "Aide-moi à obtenir une bourse pour pouvoir poursuivre mes études supérieures. Vote maintenant sur mon profil Jaangal !"
			},
			"profile": {
				"message": "Aidez {{name}} à obtenir une bourse pour pouvoir poursuivre ses études supérieures. Votez maintenant sur son profil Jaangal !"
			}
		},
		"popin": {
			"share": {
				"label": "Partager ce profil"
			},
			"copylink": {
				"label": "Copier le lien"
			}
		},
		"success_toast": {
			"title": "Vote bien pris en compte",
			"message": "Merci ! Vous pouvez voter une fois par jour."
		}
	}
}
